/** Enums. */
export var AddressType;
(function (AddressType) {
    AddressType["Basic"] = "BASIC";
})(AddressType || (AddressType = {}));
/** Enums. */
export var AuthorizationChannel;
(function (AuthorizationChannel) {
    AuthorizationChannel["Email"] = "EMAIL";
    AuthorizationChannel["Sms"] = "SMS";
})(AuthorizationChannel || (AuthorizationChannel = {}));
/** Enums. */
export var BillingType;
(function (BillingType) {
    BillingType["Business"] = "BUSINESS";
    BillingType["Personal"] = "PERSONAL";
})(BillingType || (BillingType = {}));
/** Enums. */
export var ButtonLabel;
(function (ButtonLabel) {
    ButtonLabel["A"] = "A";
    ButtonLabel["B"] = "B";
    ButtonLabel["C"] = "C";
    ButtonLabel["D"] = "D";
})(ButtonLabel || (ButtonLabel = {}));
/** Enums. */
export var CalendarDay;
(function (CalendarDay) {
    CalendarDay["Friday"] = "FRIDAY";
    CalendarDay["Monday"] = "MONDAY";
    CalendarDay["Saturday"] = "SATURDAY";
    CalendarDay["Sunday"] = "SUNDAY";
    CalendarDay["Thursday"] = "THURSDAY";
    CalendarDay["Tuesday"] = "TUESDAY";
    CalendarDay["Wednesday"] = "WEDNESDAY";
})(CalendarDay || (CalendarDay = {}));
/** Enums. */
export var Citizenship;
(function (Citizenship) {
    Citizenship["EuEeaSwitzerland"] = "EU_EEA_SWITZERLAND";
    Citizenship["Other"] = "OTHER";
    Citizenship["Polish"] = "POLISH";
})(Citizenship || (Citizenship = {}));
/** Enums. */
export var ConsentAction;
(function (ConsentAction) {
    ConsentAction["Accepted"] = "ACCEPTED";
    ConsentAction["Withdrawn"] = "WITHDRAWN";
})(ConsentAction || (ConsentAction = {}));
/** Enums. */
export var ConsentType;
(function (ConsentType) {
    ConsentType["ControllerStudentAgreement"] = "CONTROLLER_STUDENT_AGREEMENT";
    ConsentType["ControlRules"] = "CONTROL_RULES";
    ConsentType["Marketing"] = "MARKETING";
    ConsentType["Privacy"] = "PRIVACY";
    ConsentType["RecruitmentCurrent"] = "RECRUITMENT_CURRENT";
    ConsentType["RecruitmentFuture"] = "RECRUITMENT_FUTURE";
    ConsentType["Rodo"] = "RODO";
    ConsentType["TermsApp"] = "TERMS_APP";
    ConsentType["TermsParking"] = "TERMS_PARKING";
})(ConsentType || (ConsentType = {}));
/** Enums. */
export var ControllerAgreement;
(function (ControllerAgreement) {
    ControllerAgreement["Student"] = "STUDENT";
})(ControllerAgreement || (ControllerAgreement = {}));
/** Enums. */
export var CoreOrderCategory;
(function (CoreOrderCategory) {
    CoreOrderCategory["Balance"] = "BALANCE";
    CoreOrderCategory["Rental"] = "RENTAL";
})(CoreOrderCategory || (CoreOrderCategory = {}));
/** The core role of the authenticated caller. */
export var CoreRole;
(function (CoreRole) {
    /** The administrator role. */
    CoreRole["Administrator"] = "ADMINISTRATOR";
    /** The operator role. */
    CoreRole["Operator"] = "OPERATOR";
    /** The owner role. */
    CoreRole["Owner"] = "OWNER";
    /** The partner role. */
    CoreRole["Partner"] = "PARTNER";
    /** The renter role. */
    CoreRole["Renter"] = "RENTER";
})(CoreRole || (CoreRole = {}));
/** Enums. */
export var DomainErrorCode;
(function (DomainErrorCode) {
    DomainErrorCode["AggregateNotFound"] = "AGGREGATE_NOT_FOUND";
    DomainErrorCode["BasicAddressDetailsMissing"] = "BASIC_ADDRESS_DETAILS_MISSING";
    DomainErrorCode["BillingControllerAgreementAlreadySet"] = "BILLING_CONTROLLER_AGREEMENT_ALREADY_SET";
    DomainErrorCode["BillingHasActiveReservations"] = "BILLING_HAS_ACTIVE_RESERVATIONS";
    DomainErrorCode["BillingHasAssignedParkings"] = "BILLING_HAS_ASSIGNED_PARKINGS";
    DomainErrorCode["BillingPeselAlreadySet"] = "BILLING_PESEL_ALREADY_SET";
    DomainErrorCode["BillingRegonAlreadySet"] = "BILLING_REGON_ALREADY_SET";
    DomainErrorCode["BillingVatNumberAlreadySet"] = "BILLING_VAT_NUMBER_ALREADY_SET";
    DomainErrorCode["BusinessBillingRequiresVatNumber"] = "BUSINESS_BILLING_REQUIRES_VAT_NUMBER";
    DomainErrorCode["ControllerBillingNotPersonal"] = "CONTROLLER_BILLING_NOT_PERSONAL";
    DomainErrorCode["ControllerBillingStudentDataMissing"] = "CONTROLLER_BILLING_STUDENT_DATA_MISSING";
    DomainErrorCode["DefaultBillingAlreadyExists"] = "DEFAULT_BILLING_ALREADY_EXISTS";
    DomainErrorCode["DefaultBillingDeletionNotAllowed"] = "DEFAULT_BILLING_DELETION_NOT_ALLOWED";
    DomainErrorCode["DefaultPriceRuleChangeNotAllowed"] = "DEFAULT_PRICE_RULE_CHANGE_NOT_ALLOWED";
    DomainErrorCode["EmailCodeLoginRequired"] = "EMAIL_CODE_LOGIN_REQUIRED";
    DomainErrorCode["FileNotAllowed"] = "FILE_NOT_ALLOWED";
    DomainErrorCode["FileNotFound"] = "FILE_NOT_FOUND";
    DomainErrorCode["FileSignatureExpired"] = "FILE_SIGNATURE_EXPIRED";
    DomainErrorCode["InsufficientWalletBalance"] = "INSUFFICIENT_WALLET_BALANCE";
    DomainErrorCode["InvalidBankAccountOwnership"] = "INVALID_BANK_ACCOUNT_OWNERSHIP";
    DomainErrorCode["InvalidBillingOwnership"] = "INVALID_BILLING_OWNERSHIP";
    DomainErrorCode["InvalidLoginCredentials"] = "INVALID_LOGIN_CREDENTIALS";
    DomainErrorCode["InvalidOvernightPeriod"] = "INVALID_OVERNIGHT_PERIOD";
    DomainErrorCode["InvalidReservationOwnership"] = "INVALID_RESERVATION_OWNERSHIP";
    DomainErrorCode["InvalidSameDayPeriod"] = "INVALID_SAME_DAY_PERIOD";
    DomainErrorCode["InvalidTicketableReference"] = "INVALID_TICKETABLE_REFERENCE";
    DomainErrorCode["InvalidTicketOwnership"] = "INVALID_TICKET_OWNERSHIP";
    DomainErrorCode["InvalidValueObject"] = "INVALID_VALUE_OBJECT";
    DomainErrorCode["InvalidVehicleOwnership"] = "INVALID_VEHICLE_OWNERSHIP";
    DomainErrorCode["InvitationAcceptedStatusNotAllowed"] = "INVITATION_ACCEPTED_STATUS_NOT_ALLOWED";
    DomainErrorCode["InvitationCanceledStatusNotAllowed"] = "INVITATION_CANCELED_STATUS_NOT_ALLOWED";
    DomainErrorCode["InvitationCompletedStatusNotAllowed"] = "INVITATION_COMPLETED_STATUS_NOT_ALLOWED";
    DomainErrorCode["InvitationExpired"] = "INVITATION_EXPIRED";
    DomainErrorCode["InvitationExpiredStatusNotAllowed"] = "INVITATION_EXPIRED_STATUS_NOT_ALLOWED";
    DomainErrorCode["InvitationNotPending"] = "INVITATION_NOT_PENDING";
    DomainErrorCode["LoginPasswordMissing"] = "LOGIN_PASSWORD_MISSING";
    DomainErrorCode["MembershipNotFound"] = "MEMBERSHIP_NOT_FOUND";
    DomainErrorCode["OneTimeUnavailabilityPlanPeriodMissing"] = "ONE_TIME_UNAVAILABILITY_PLAN_PERIOD_MISSING";
    DomainErrorCode["OrderCanceledStatusNotAllowed"] = "ORDER_CANCELED_STATUS_NOT_ALLOWED";
    DomainErrorCode["OrderCancellationNotAllowed"] = "ORDER_CANCELLATION_NOT_ALLOWED";
    DomainErrorCode["OrderCompletedStatusNotAllowed"] = "ORDER_COMPLETED_STATUS_NOT_ALLOWED";
    DomainErrorCode["OrderCompletionNotAllowed"] = "ORDER_COMPLETION_NOT_ALLOWED";
    DomainErrorCode["OrderCorrectedAmountExceeded"] = "ORDER_CORRECTED_AMOUNT_EXCEEDED";
    DomainErrorCode["OrderCorrectedDirectionNotAllowed"] = "ORDER_CORRECTED_DIRECTION_NOT_ALLOWED";
    DomainErrorCode["OrderCorrectedStatusNotAllowed"] = "ORDER_CORRECTED_STATUS_NOT_ALLOWED";
    DomainErrorCode["OrderFulfilledStatusNotAllowed"] = "ORDER_FULFILLED_STATUS_NOT_ALLOWED";
    DomainErrorCode["OrderPaidStatusNotAllowed"] = "ORDER_PAID_STATUS_NOT_ALLOWED";
    DomainErrorCode["OrganizationAccountAlreadyProvisioned"] = "ORGANIZATION_ACCOUNT_ALREADY_PROVISIONED";
    DomainErrorCode["ParkingActiveStatusNotAllowed"] = "PARKING_ACTIVE_STATUS_NOT_ALLOWED";
    DomainErrorCode["ParkingHasActiveReservation"] = "PARKING_HAS_ACTIVE_RESERVATION";
    DomainErrorCode["ParkingIdentifierPoolExhausted"] = "PARKING_IDENTIFIER_POOL_EXHAUSTED";
    DomainErrorCode["ParkingNotSuspended"] = "PARKING_NOT_SUSPENDED";
    DomainErrorCode["ParkingPausedStatusNotAllowed"] = "PARKING_PAUSED_STATUS_NOT_ALLOWED";
    DomainErrorCode["ParkingPointNoBasicAddress"] = "PARKING_POINT_NO_BASIC_ADDRESS";
    DomainErrorCode["ParkingPointPathNodeAlreadyExists"] = "PARKING_POINT_PATH_NODE_ALREADY_EXISTS";
    DomainErrorCode["ParkingPointPathNodeMissing"] = "PARKING_POINT_PATH_NODE_MISSING";
    DomainErrorCode["ParkingPointPathNodeNotAllowed"] = "PARKING_POINT_PATH_NODE_NOT_ALLOWED";
    DomainErrorCode["ParkingPointTooFar"] = "PARKING_POINT_TOO_FAR";
    DomainErrorCode["ParkingSuspendedStatusNotAllowed"] = "PARKING_SUSPENDED_STATUS_NOT_ALLOWED";
    DomainErrorCode["ParkingVehicleAlreadyExists"] = "PARKING_VEHICLE_ALREADY_EXISTS";
    DomainErrorCode["ParkingVehicleLimitReached"] = "PARKING_VEHICLE_LIMIT_REACHED";
    DomainErrorCode["ParkingWithoutSignage"] = "PARKING_WITHOUT_SIGNAGE";
    DomainErrorCode["PasswordLoginNotAllowed"] = "PASSWORD_LOGIN_NOT_ALLOWED";
    DomainErrorCode["PasswordLoginRequired"] = "PASSWORD_LOGIN_REQUIRED";
    DomainErrorCode["PaymentCannotBeRetried"] = "PAYMENT_CANNOT_BE_RETRIED";
    DomainErrorCode["PaymentExternalIdsAlreadySet"] = "PAYMENT_EXTERNAL_IDS_ALREADY_SET";
    DomainErrorCode["PaymentFailedStatusNotAllowed"] = "PAYMENT_FAILED_STATUS_NOT_ALLOWED";
    DomainErrorCode["PaymentMethodRequired"] = "PAYMENT_METHOD_REQUIRED";
    DomainErrorCode["PaymentRefundedAmountExceeded"] = "PAYMENT_REFUNDED_AMOUNT_EXCEEDED";
    DomainErrorCode["PaymentRefundedAmountNotAllowed"] = "PAYMENT_REFUNDED_AMOUNT_NOT_ALLOWED";
    DomainErrorCode["PaymentRefundedStatusNotAllowed"] = "PAYMENT_REFUNDED_STATUS_NOT_ALLOWED";
    DomainErrorCode["PaymentRefundOutcomeNotAllowed"] = "PAYMENT_REFUND_OUTCOME_NOT_ALLOWED";
    DomainErrorCode["PaymentSucceededStatusNotAllowed"] = "PAYMENT_SUCCEEDED_STATUS_NOT_ALLOWED";
    DomainErrorCode["PeriodEndBeforeStart"] = "PERIOD_END_BEFORE_START";
    DomainErrorCode["PlannedNotificationNotFound"] = "PLANNED_NOTIFICATION_NOT_FOUND";
    DomainErrorCode["PriceRuleAlreadyExists"] = "PRICE_RULE_ALREADY_EXISTS";
    DomainErrorCode["PriceRuleNotAvailableOnDay"] = "PRICE_RULE_NOT_AVAILABLE_ON_DAY";
    DomainErrorCode["PriceRuleNotPurchasable"] = "PRICE_RULE_NOT_PURCHASABLE";
    DomainErrorCode["PriceRulePeriodChangeNotAllowed"] = "PRICE_RULE_PERIOD_CHANGE_NOT_ALLOWED";
    DomainErrorCode["PriceRuleWindowClosed"] = "PRICE_RULE_WINDOW_CLOSED";
    DomainErrorCode["PricingRulesMissing"] = "PRICING_RULES_MISSING";
    DomainErrorCode["ReferralCodeNotFound"] = "REFERRAL_CODE_NOT_FOUND";
    DomainErrorCode["RequiredArgumentMissing"] = "REQUIRED_ARGUMENT_MISSING";
    DomainErrorCode["ReservationActiveStatusNotAllowed"] = "RESERVATION_ACTIVE_STATUS_NOT_ALLOWED";
    DomainErrorCode["ReservationAlreadyPaid"] = "RESERVATION_ALREADY_PAID";
    DomainErrorCode["ReservationAlreadyRevolving"] = "RESERVATION_ALREADY_REVOLVING";
    DomainErrorCode["ReservationBillingNotAssigned"] = "RESERVATION_BILLING_NOT_ASSIGNED";
    DomainErrorCode["ReservationCanceledStatusNotAllowed"] = "RESERVATION_CANCELED_STATUS_NOT_ALLOWED";
    DomainErrorCode["ReservationCompletedStatusNotAllowed"] = "RESERVATION_COMPLETED_STATUS_NOT_ALLOWED";
    DomainErrorCode["ReservationConfirmationNotAllowed"] = "RESERVATION_CONFIRMATION_NOT_ALLOWED";
    DomainErrorCode["ReservationExpiredStatusNotAllowed"] = "RESERVATION_EXPIRED_STATUS_NOT_ALLOWED";
    DomainErrorCode["ReservationExtensionEndDateInvalid"] = "RESERVATION_EXTENSION_END_DATE_INVALID";
    DomainErrorCode["ReservationHorizonExceeded"] = "RESERVATION_HORIZON_EXCEEDED";
    DomainErrorCode["ReservationLastVehicle"] = "RESERVATION_LAST_VEHICLE";
    DomainErrorCode["ReservationLockExpired"] = "RESERVATION_LOCK_EXPIRED";
    DomainErrorCode["ReservationNotActive"] = "RESERVATION_NOT_ACTIVE";
    DomainErrorCode["ReservationNotConfirmed"] = "RESERVATION_NOT_CONFIRMED";
    DomainErrorCode["ReservationNotPending"] = "RESERVATION_NOT_PENDING";
    DomainErrorCode["ReservationNotRevolving"] = "RESERVATION_NOT_REVOLVING";
    DomainErrorCode["ReservationRegistrationNumberAlreadyAdded"] = "RESERVATION_REGISTRATION_NUMBER_ALREADY_ADDED";
    DomainErrorCode["ReservationRevolvingHoldConflict"] = "RESERVATION_REVOLVING_HOLD_CONFLICT";
    DomainErrorCode["ReservationRevolvingNotAllowedByPriceRule"] = "RESERVATION_REVOLVING_NOT_ALLOWED_BY_PRICE_RULE";
    DomainErrorCode["ReservationRevolvingSpotMissing"] = "RESERVATION_REVOLVING_SPOT_MISSING";
    DomainErrorCode["ReservationRevolvingStatusNotAllowed"] = "RESERVATION_REVOLVING_STATUS_NOT_ALLOWED";
    DomainErrorCode["ReservationSpanActiveStatusNotAllowed"] = "RESERVATION_SPAN_ACTIVE_STATUS_NOT_ALLOWED";
    DomainErrorCode["ReservationSpanCanceledStatusNotAllowed"] = "RESERVATION_SPAN_CANCELED_STATUS_NOT_ALLOWED";
    DomainErrorCode["ReservationSpanCompletedStatusNotAllowed"] = "RESERVATION_SPAN_COMPLETED_STATUS_NOT_ALLOWED";
    DomainErrorCode["ReservationSpanExtendedStatusNotAllowed"] = "RESERVATION_SPAN_EXTENDED_STATUS_NOT_ALLOWED";
    DomainErrorCode["ReservationSpanExtensionLockExpired"] = "RESERVATION_SPAN_EXTENSION_LOCK_EXPIRED";
    DomainErrorCode["ReservationSpanNotActive"] = "RESERVATION_SPAN_NOT_ACTIVE";
    DomainErrorCode["ReservationSpanNotPayable"] = "RESERVATION_SPAN_NOT_PAYABLE";
    DomainErrorCode["ReservationSpanPaymentLinkInvalid"] = "RESERVATION_SPAN_PAYMENT_LINK_INVALID";
    DomainErrorCode["ReservationSpanPaymentNotAllowed"] = "RESERVATION_SPAN_PAYMENT_NOT_ALLOWED";
    DomainErrorCode["ReservationSpanScheduledStatusNotAllowed"] = "RESERVATION_SPAN_SCHEDULED_STATUS_NOT_ALLOWED";
    DomainErrorCode["ReservationSpanSpotReassignmentNotAllowed"] = "RESERVATION_SPAN_SPOT_REASSIGNMENT_NOT_ALLOWED";
    DomainErrorCode["ReservationUserAlreadyAssigned"] = "RESERVATION_USER_ALREADY_ASSIGNED";
    DomainErrorCode["ReservationVehicleLimitReached"] = "RESERVATION_VEHICLE_LIMIT_REACHED";
    DomainErrorCode["ReservationVehicleMissing"] = "RESERVATION_VEHICLE_MISSING";
    DomainErrorCode["ReservationVehicleNotAssigned"] = "RESERVATION_VEHICLE_NOT_ASSIGNED";
    DomainErrorCode["ReservationVehicleSealed"] = "RESERVATION_VEHICLE_SEALED";
    DomainErrorCode["ReservationVehicleStatusNotAllowed"] = "RESERVATION_VEHICLE_STATUS_NOT_ALLOWED";
    DomainErrorCode["ReverificationRequired"] = "REVERIFICATION_REQUIRED";
    DomainErrorCode["SpotAlreadyBlocked"] = "SPOT_ALREADY_BLOCKED";
    DomainErrorCode["SpotDimensionsMissing"] = "SPOT_DIMENSIONS_MISSING";
    DomainErrorCode["SpotHasActiveReservation"] = "SPOT_HAS_ACTIVE_RESERVATION";
    DomainErrorCode["SpotLockCodeMissing"] = "SPOT_LOCK_CODE_MISSING";
    DomainErrorCode["SpotNotBlocked"] = "SPOT_NOT_BLOCKED";
    DomainErrorCode["SpotNumberAlreadyExists"] = "SPOT_NUMBER_ALREADY_EXISTS";
    DomainErrorCode["SpotPausedStatusNotAllowed"] = "SPOT_PAUSED_STATUS_NOT_ALLOWED";
    DomainErrorCode["SpotSuspendedStatusNotAllowed"] = "SPOT_SUSPENDED_STATUS_NOT_ALLOWED";
    DomainErrorCode["SystemAccountLoginNotAllowed"] = "SYSTEM_ACCOUNT_LOGIN_NOT_ALLOWED";
    DomainErrorCode["TicketClosedStatusNotAllowed"] = "TICKET_CLOSED_STATUS_NOT_ALLOWED";
    DomainErrorCode["TicketInProgressStatusNotAllowed"] = "TICKET_IN_PROGRESS_STATUS_NOT_ALLOWED";
    DomainErrorCode["TicketNewStatusNotAllowed"] = "TICKET_NEW_STATUS_NOT_ALLOWED";
    DomainErrorCode["TicketOpenStatusNotAllowed"] = "TICKET_OPEN_STATUS_NOT_ALLOWED";
    DomainErrorCode["TicketReopenedStatusNotAllowed"] = "TICKET_REOPENED_STATUS_NOT_ALLOWED";
    DomainErrorCode["TicketResolvedStatusNotAllowed"] = "TICKET_RESOLVED_STATUS_NOT_ALLOWED";
    DomainErrorCode["TicketUserAlreadyAssigned"] = "TICKET_USER_ALREADY_ASSIGNED";
    DomainErrorCode["UnavailabilityRuleAlreadyExists"] = "UNAVAILABILITY_RULE_ALREADY_EXISTS";
    DomainErrorCode["UserCannotReferThemselves"] = "USER_CANNOT_REFER_THEMSELVES";
    DomainErrorCode["UserEmailAlreadyTaken"] = "USER_EMAIL_ALREADY_TAKEN";
    DomainErrorCode["UserIsAlreadyPartner"] = "USER_IS_ALREADY_PARTNER";
    DomainErrorCode["UserIsAlreadyReferred"] = "USER_IS_ALREADY_REFERRED";
    DomainErrorCode["UserIsNotTemporary"] = "USER_IS_NOT_TEMPORARY";
    DomainErrorCode["VehicleAlreadyExists"] = "VEHICLE_ALREADY_EXISTS";
    DomainErrorCode["VehicleInUse"] = "VEHICLE_IN_USE";
    DomainErrorCode["VerificationCodeNotExpired"] = "VERIFICATION_CODE_NOT_EXPIRED";
    DomainErrorCode["VerificationCodePoolExhausted"] = "VERIFICATION_CODE_POOL_EXHAUSTED";
})(DomainErrorCode || (DomainErrorCode = {}));
/** Enums. */
export var E2eParkingFixtureState;
(function (E2eParkingFixtureState) {
    E2eParkingFixtureState["Active"] = "ACTIVE";
    E2eParkingFixtureState["BillingAssigned"] = "BILLING_ASSIGNED";
    E2eParkingFixtureState["Draft"] = "DRAFT";
    E2eParkingFixtureState["PendingVerification"] = "PENDING_VERIFICATION";
})(E2eParkingFixtureState || (E2eParkingFixtureState = {}));
/** Enums. */
export var E2eReservationFixtureState;
(function (E2eReservationFixtureState) {
    E2eReservationFixtureState["Active"] = "ACTIVE";
    E2eReservationFixtureState["Canceled"] = "CANCELED";
    E2eReservationFixtureState["Completed"] = "COMPLETED";
    E2eReservationFixtureState["Confirmed"] = "CONFIRMED";
    E2eReservationFixtureState["Expired"] = "EXPIRED";
    E2eReservationFixtureState["Pending"] = "PENDING";
})(E2eReservationFixtureState || (E2eReservationFixtureState = {}));
/** The email verification statuses. */
export var EmailVerificationStatus;
(function (EmailVerificationStatus) {
    /** The verified email status. */
    EmailVerificationStatus["Verified"] = "VERIFIED";
})(EmailVerificationStatus || (EmailVerificationStatus = {}));
/** Enums. */
export var FileScope;
(function (FileScope) {
    /** The sign PDF, addressed by: parking identifier, sign type, [spot number for a spot sign,] template, format. */
    FileScope["Sign"] = "SIGN";
})(FileScope || (FileScope = {}));
/** The forgot password statuses. */
export var ForgotPasswordStatus;
(function (ForgotPasswordStatus) {
    /** The sent email status. */
    ForgotPasswordStatus["EmailSent"] = "EMAIL_SENT";
})(ForgotPasswordStatus || (ForgotPasswordStatus = {}));
/** Enums. */
export var GateCategory;
(function (GateCategory) {
    GateCategory["Entry"] = "ENTRY";
    GateCategory["Exit"] = "EXIT";
    GateCategory["Floor"] = "FLOOR";
    GateCategory["Garage"] = "GARAGE";
    GateCategory["Other"] = "OTHER";
    GateCategory["Zone"] = "ZONE";
})(GateCategory || (GateCategory = {}));
/** Enums. */
export var GateOpeningRequestFailureReason;
(function (GateOpeningRequestFailureReason) {
    GateOpeningRequestFailureReason["AllProvidersFailed"] = "ALL_PROVIDERS_FAILED";
    GateOpeningRequestFailureReason["Answered"] = "ANSWERED";
    GateOpeningRequestFailureReason["ControllerUnavailable"] = "CONTROLLER_UNAVAILABLE";
    GateOpeningRequestFailureReason["DispatchFailed"] = "DISPATCH_FAILED";
    GateOpeningRequestFailureReason["MissingPhoneNumber"] = "MISSING_PHONE_NUMBER";
    GateOpeningRequestFailureReason["WebhookTimeout"] = "WEBHOOK_TIMEOUT";
})(GateOpeningRequestFailureReason || (GateOpeningRequestFailureReason = {}));
/** Enums. */
export var GateOpeningRequestStatus;
(function (GateOpeningRequestStatus) {
    GateOpeningRequestStatus["Dispatched"] = "DISPATCHED";
    GateOpeningRequestStatus["Failed"] = "FAILED";
    GateOpeningRequestStatus["Queued"] = "QUEUED";
    GateOpeningRequestStatus["Reached"] = "REACHED";
})(GateOpeningRequestStatus || (GateOpeningRequestStatus = {}));
/** Enums. */
export var GateStatus;
(function (GateStatus) {
    GateStatus["Active"] = "ACTIVE";
    GateStatus["Inactive"] = "INACTIVE";
})(GateStatus || (GateStatus = {}));
/** Enums. */
export var GateType;
(function (GateType) {
    GateType["Barrier"] = "BARRIER";
    GateType["Gate"] = "GATE";
    GateType["Other"] = "OTHER";
})(GateType || (GateType = {}));
/** Enums. */
export var ImageSize;
(function (ImageSize) {
    ImageSize["Large"] = "LARGE";
    ImageSize["Medium"] = "MEDIUM";
    ImageSize["Small"] = "SMALL";
})(ImageSize || (ImageSize = {}));
/** Enums. */
export var ImageStatus;
(function (ImageStatus) {
    ImageStatus["Converted"] = "CONVERTED";
    ImageStatus["Uploaded"] = "UPLOADED";
})(ImageStatus || (ImageStatus = {}));
/** Enums. */
export var ImageType;
(function (ImageType) {
    ImageType["Default"] = "DEFAULT";
    ImageType["MainSign"] = "MAIN_SIGN";
    ImageType["Regulations"] = "REGULATIONS";
})(ImageType || (ImageType = {}));
/** Enums. */
export var InvitationStatus;
(function (InvitationStatus) {
    InvitationStatus["Accepted"] = "ACCEPTED";
    InvitationStatus["Canceled"] = "CANCELED";
    InvitationStatus["Completed"] = "COMPLETED";
    InvitationStatus["Expired"] = "EXPIRED";
    InvitationStatus["Pending"] = "PENDING";
})(InvitationStatus || (InvitationStatus = {}));
/** Enums. */
export var Language;
(function (Language) {
    Language["English"] = "ENGLISH";
    Language["Polish"] = "POLISH";
})(Language || (Language = {}));
/** Enums. */
export var LiftDoorState;
(function (LiftDoorState) {
    LiftDoorState["Closed"] = "CLOSED";
    LiftDoorState["Open"] = "OPEN";
})(LiftDoorState || (LiftDoorState = {}));
/** Enums. */
export var LiftMovementState;
(function (LiftMovementState) {
    LiftMovementState["Idle"] = "IDLE";
    LiftMovementState["MovingDown"] = "MOVING_DOWN";
    LiftMovementState["MovingUp"] = "MOVING_UP";
})(LiftMovementState || (LiftMovementState = {}));
/** Enums. */
export var LoginMethod;
(function (LoginMethod) {
    LoginMethod["EmailCode"] = "EMAIL_CODE";
    LoginMethod["Password"] = "PASSWORD";
})(LoginMethod || (LoginMethod = {}));
/** The logout statuses. */
export var LogoutStatus;
(function (LogoutStatus) {
    /** The revoked token status. */
    LogoutStatus["TokenRevoked"] = "TOKEN_REVOKED";
})(LogoutStatus || (LogoutStatus = {}));
/** Enums. */
export var MemberRole;
(function (MemberRole) {
    MemberRole["Administrator"] = "ADMINISTRATOR";
    MemberRole["Member"] = "MEMBER";
    MemberRole["Owner"] = "OWNER";
})(MemberRole || (MemberRole = {}));
/** The notification type. */
export var NotificationType;
(function (NotificationType) {
    /** The authorization code notification. */
    NotificationType["AuthorizationCode"] = "AUTHORIZATION_CODE";
    /** The email verification notification. */
    NotificationType["EmailVerification"] = "EMAIL_VERIFICATION";
    /** The signs of many parking spots notification. */
    NotificationType["ManyParkingSpotsSigns"] = "MANY_PARKING_SPOTS_SIGNS";
    /** The canceled order notification. */
    NotificationType["OrderCanceled"] = "ORDER_CANCELED";
    /** The completed order notification. */
    NotificationType["OrderCompleted"] = "ORDER_COMPLETED";
    /** The organization invitation notification. */
    NotificationType["OrganizationInvitation"] = "ORGANIZATION_INVITATION";
    /** The activated parking notification. */
    NotificationType["ParkingActivated"] = "PARKING_ACTIVATED";
    /** The created parking notification. */
    NotificationType["ParkingCreated"] = "PARKING_CREATED";
    /** The rejected parking notification. */
    NotificationType["ParkingRejected"] = "PARKING_REJECTED";
    /** The parking signs notification. */
    NotificationType["ParkingSigns"] = "PARKING_SIGNS";
    /** The parking spot signs notification. */
    NotificationType["ParkingSpotSigns"] = "PARKING_SPOT_SIGNS";
    /** The created partner notification. */
    NotificationType["PartnerCreated"] = "PARTNER_CREATED";
    /** The generated password notification. */
    NotificationType["PasswordGenerated"] = "PASSWORD_GENERATED";
    /** The payment document mail. */
    NotificationType["PaymentDocument"] = "PAYMENT_DOCUMENT";
    /** The unprocessed payment notification. */
    NotificationType["PaymentNotificationNotProcessed"] = "PAYMENT_NOTIFICATION_NOT_PROCESSED";
    /** The copy of a planned email sent to the administrator asking for it. */
    NotificationType["PlannedNotificationCopy"] = "PLANNED_NOTIFICATION_COPY";
    /** The long queue wait time notification. */
    NotificationType["QueueHasLongWaitTime"] = "QUEUE_HAS_LONG_WAIT_TIME";
    /** The completed reservation notification sent to the parking owner. */
    NotificationType["ReservationCompletedOwner"] = "RESERVATION_COMPLETED_OWNER";
    /** The completed reservation notification sent to the renter. */
    NotificationType["ReservationCompletedRenter"] = "RESERVATION_COMPLETED_RENTER";
    /** The created reservation notification sent to the parking owner. */
    NotificationType["ReservationCreatedOwner"] = "RESERVATION_CREATED_OWNER";
    /** The created reservation notification sent to the renter. */
    NotificationType["ReservationCreatedRenter"] = "RESERVATION_CREATED_RENTER";
    /** The revolving reservation reminder notification. */
    NotificationType["ReservationRevolvingReminder"] = "RESERVATION_REVOLVING_REMINDER";
    /** The reservation span reminder notification. */
    NotificationType["ReservationSpanReminder"] = "RESERVATION_SPAN_REMINDER";
    /** The moved reservation span notification sent to the renter. */
    NotificationType["ReservationSpanSpotReassigned"] = "RESERVATION_SPAN_SPOT_REASSIGNED";
    /** The reservation span starting soon notification. */
    NotificationType["ReservationSpanStartingSoon"] = "RESERVATION_SPAN_STARTING_SOON";
    /** The created spot notification. */
    NotificationType["SpotCreated"] = "SPOT_CREATED";
    /** The ready spot signs archive mail. */
    NotificationType["SpotSignsZipReady"] = "SPOT_SIGNS_ZIP_READY";
    /** The accepted ParkApp controller notification. */
    NotificationType["SystemControllerAccepted"] = "SYSTEM_CONTROLLER_ACCEPTED";
    /** The activated ParkApp controller notification. */
    NotificationType["SystemControllerActivated"] = "SYSTEM_CONTROLLER_ACTIVATED";
    /** The terms signs notification. */
    NotificationType["TermsSigns"] = "TERMS_SIGNS";
    /** The created ticket notification. */
    NotificationType["TicketCreated"] = "TICKET_CREATED";
    /** The ticket message notification sent to the assignee. */
    NotificationType["TicketMessagePostedAssignee"] = "TICKET_MESSAGE_POSTED_ASSIGNEE";
    /** The ticket message notification sent to the person who raised the ticket. */
    NotificationType["TicketMessagePostedOwner"] = "TICKET_MESSAGE_POSTED_OWNER";
    /** The changed ticket status notification. */
    NotificationType["TicketStatusChanged"] = "TICKET_STATUS_CHANGED";
    /** The assigned ticket notification. */
    NotificationType["TicketUserAssigned"] = "TICKET_USER_ASSIGNED";
})(NotificationType || (NotificationType = {}));
/** Aggregate functions when ordering by a relation without specifying a column. */
export var OrderByRelationAggregateFunction;
(function (OrderByRelationAggregateFunction) {
    /** Amount of items. */
    OrderByRelationAggregateFunction["Count"] = "COUNT";
})(OrderByRelationAggregateFunction || (OrderByRelationAggregateFunction = {}));
/** Aggregate functions when ordering by a relation that may specify a column. */
export var OrderByRelationWithColumnAggregateFunction;
(function (OrderByRelationWithColumnAggregateFunction) {
    /** Average. */
    OrderByRelationWithColumnAggregateFunction["Avg"] = "AVG";
    /** Amount of items. */
    OrderByRelationWithColumnAggregateFunction["Count"] = "COUNT";
    /** Maximum. */
    OrderByRelationWithColumnAggregateFunction["Max"] = "MAX";
    /** Minimum. */
    OrderByRelationWithColumnAggregateFunction["Min"] = "MIN";
    /** Sum. */
    OrderByRelationWithColumnAggregateFunction["Sum"] = "SUM";
})(OrderByRelationWithColumnAggregateFunction || (OrderByRelationWithColumnAggregateFunction = {}));
/** Enums. */
export var OrderDirection;
(function (OrderDirection) {
    OrderDirection["Charge"] = "CHARGE";
    OrderDirection["Correction"] = "CORRECTION";
})(OrderDirection || (OrderDirection = {}));
/** Enums. */
export var OrderProduct;
(function (OrderProduct) {
    OrderProduct["BalanceTopUp"] = "BALANCE_TOP_UP";
    OrderProduct["ParkingSpotRental"] = "PARKING_SPOT_RENTAL";
    OrderProduct["ParkingSpotRentalExtension"] = "PARKING_SPOT_RENTAL_EXTENSION";
})(OrderProduct || (OrderProduct = {}));
/** Enums. */
export var OrderStatus;
(function (OrderStatus) {
    OrderStatus["Canceled"] = "CANCELED";
    OrderStatus["Completed"] = "COMPLETED";
    OrderStatus["Fulfilled"] = "FULFILLED";
    OrderStatus["Paid"] = "PAID";
    OrderStatus["Placed"] = "PLACED";
})(OrderStatus || (OrderStatus = {}));
/** Enums. */
export var OrganizationStatus;
(function (OrganizationStatus) {
    OrganizationStatus["Active"] = "ACTIVE";
    OrganizationStatus["Inactive"] = "INACTIVE";
    OrganizationStatus["Pending"] = "PENDING";
})(OrganizationStatus || (OrganizationStatus = {}));
/** Enums. */
export var OrganizationType;
(function (OrganizationType) {
    OrganizationType["Community"] = "COMMUNITY";
    OrganizationType["Company"] = "COMPANY";
    OrganizationType["Other"] = "OTHER";
})(OrganizationType || (OrganizationType = {}));
/** Enums. */
export var PanelDomainErrorCode;
(function (PanelDomainErrorCode) {
    PanelDomainErrorCode["AgeRangeNotApplicable"] = "AGE_RANGE_NOT_APPLICABLE";
    PanelDomainErrorCode["AggregateNotFound"] = "AGGREGATE_NOT_FOUND";
    PanelDomainErrorCode["BankStatementAlreadyImported"] = "BANK_STATEMENT_ALREADY_IMPORTED";
    PanelDomainErrorCode["BankStatementLineAlreadyIgnored"] = "BANK_STATEMENT_LINE_ALREADY_IGNORED";
    PanelDomainErrorCode["BankStatementLineAlreadyQualified"] = "BANK_STATEMENT_LINE_ALREADY_QUALIFIED";
    PanelDomainErrorCode["BankStatementLineNotCredit"] = "BANK_STATEMENT_LINE_NOT_CREDIT";
    PanelDomainErrorCode["BankStatementLineNotFound"] = "BANK_STATEMENT_LINE_NOT_FOUND";
    PanelDomainErrorCode["BoundCaseNotFound"] = "BOUND_CASE_NOT_FOUND";
    PanelDomainErrorCode["CaseAlreadyExists"] = "CASE_ALREADY_EXISTS";
    PanelDomainErrorCode["CaseAttachmentNotFound"] = "CASE_ATTACHMENT_NOT_FOUND";
    PanelDomainErrorCode["CaseCannotBeMarkedAsOwnDuplicate"] = "CASE_CANNOT_BE_MARKED_AS_OWN_DUPLICATE";
    PanelDomainErrorCode["CaseNoteEditWindowExpired"] = "CASE_NOTE_EDIT_WINDOW_EXPIRED";
    PanelDomainErrorCode["CaseNotEditable"] = "CASE_NOT_EDITABLE";
    PanelDomainErrorCode["CommissionSchemeVersionAlreadyPublished"] = "COMMISSION_SCHEME_VERSION_ALREADY_PUBLISHED";
    PanelDomainErrorCode["ConflictingActiveParkingAssignment"] = "CONFLICTING_ACTIVE_PARKING_ASSIGNMENT";
    PanelDomainErrorCode["ConflictingActiveRelation"] = "CONFLICTING_ACTIVE_RELATION";
    PanelDomainErrorCode["ConflictingSchemeVersionNumber"] = "CONFLICTING_SCHEME_VERSION_NUMBER";
    PanelDomainErrorCode["DuplicateBankStatementLine"] = "DUPLICATE_BANK_STATEMENT_LINE";
    PanelDomainErrorCode["DuplicateChainNotAllowed"] = "DUPLICATE_CHAIN_NOT_ALLOWED";
    PanelDomainErrorCode["DuplicateCommissionSchemeRule"] = "DUPLICATE_COMMISSION_SCHEME_RULE";
    PanelDomainErrorCode["DuplicateReferralCode"] = "DUPLICATE_REFERRAL_CODE";
    PanelDomainErrorCode["DuplicateSchemeCode"] = "DUPLICATE_SCHEME_CODE";
    PanelDomainErrorCode["DuplicateSchemeVersionValidFrom"] = "DUPLICATE_SCHEME_VERSION_VALID_FROM";
    PanelDomainErrorCode["ExampleRuleViolation"] = "EXAMPLE_RULE_VIOLATION";
    PanelDomainErrorCode["IllegalCaseWorkingStatusTransition"] = "ILLEGAL_CASE_WORKING_STATUS_TRANSITION";
    PanelDomainErrorCode["IllegalInvitationStatusTransition"] = "ILLEGAL_INVITATION_STATUS_TRANSITION";
    PanelDomainErrorCode["IllegalThreadStatusTransition"] = "ILLEGAL_THREAD_STATUS_TRANSITION";
    PanelDomainErrorCode["IllegalUnauthorizedUsePaymentStatusTransition"] = "ILLEGAL_UNAUTHORIZED_USE_PAYMENT_STATUS_TRANSITION";
    PanelDomainErrorCode["InactiveInvitationTemplate"] = "INACTIVE_INVITATION_TEMPLATE";
    PanelDomainErrorCode["InvalidAgeRange"] = "INVALID_AGE_RANGE";
    PanelDomainErrorCode["InvalidBulkChangeRelationSubset"] = "INVALID_BULK_CHANGE_RELATION_SUBSET";
    PanelDomainErrorCode["InvalidReferralCodeValidity"] = "INVALID_REFERRAL_CODE_VALIDITY";
    PanelDomainErrorCode["InvalidRuleParameters"] = "INVALID_RULE_PARAMETERS";
    PanelDomainErrorCode["InvalidThreadContext"] = "INVALID_THREAD_CONTEXT";
    PanelDomainErrorCode["InvalidValueObject"] = "INVALID_VALUE_OBJECT";
    PanelDomainErrorCode["InvitationChannelMismatch"] = "INVITATION_CHANNEL_MISMATCH";
    PanelDomainErrorCode["InvitationSendLimitReached"] = "INVITATION_SEND_LIMIT_REACHED";
    PanelDomainErrorCode["MessageNotModeratable"] = "MESSAGE_NOT_MODERATABLE";
    PanelDomainErrorCode["OverlappingAgeRanges"] = "OVERLAPPING_AGE_RANGES";
    PanelDomainErrorCode["OwnerReplyNotPendingReview"] = "OWNER_REPLY_NOT_PENDING_REVIEW";
    PanelDomainErrorCode["ParkingAssignmentAlreadyEnded"] = "PARKING_ASSIGNMENT_ALREADY_ENDED";
    PanelDomainErrorCode["ParkingNotReachable"] = "PARKING_NOT_REACHABLE";
    PanelDomainErrorCode["ReferralCodeExhausted"] = "REFERRAL_CODE_EXHAUSTED";
    PanelDomainErrorCode["ReferralCodeExpired"] = "REFERRAL_CODE_EXPIRED";
    PanelDomainErrorCode["ReferralCodeNotActive"] = "REFERRAL_CODE_NOT_ACTIVE";
    PanelDomainErrorCode["RelationAlreadyEnded"] = "RELATION_ALREADY_ENDED";
    PanelDomainErrorCode["RelationTypeNotBulkEditable"] = "RELATION_TYPE_NOT_BULK_EDITABLE";
    PanelDomainErrorCode["SpotNotOnParking"] = "SPOT_NOT_ON_PARKING";
    PanelDomainErrorCode["ThreadAlreadyClosed"] = "THREAD_ALREADY_CLOSED";
    PanelDomainErrorCode["TicketNotFound"] = "TICKET_NOT_FOUND";
    PanelDomainErrorCode["TicketNotUnauthorizedUse"] = "TICKET_NOT_UNAUTHORIZED_USE";
    PanelDomainErrorCode["UnauthorizedUsePaymentAlreadyBound"] = "UNAUTHORIZED_USE_PAYMENT_ALREADY_BOUND";
    PanelDomainErrorCode["UnauthorizedUsePaymentNotFound"] = "UNAUTHORIZED_USE_PAYMENT_NOT_FOUND";
    PanelDomainErrorCode["UnauthorizedUsePaymentSourceLinkMismatch"] = "UNAUTHORIZED_USE_PAYMENT_SOURCE_LINK_MISMATCH";
    PanelDomainErrorCode["VehicleAlreadyReported"] = "VEHICLE_ALREADY_REPORTED";
})(PanelDomainErrorCode || (PanelDomainErrorCode = {}));
/** Enums. */
export var ParkingPointType;
(function (ParkingPointType) {
    ParkingPointType["Entrance"] = "ENTRANCE";
    ParkingPointType["Exit"] = "EXIT";
    ParkingPointType["Path"] = "PATH";
})(ParkingPointType || (ParkingPointType = {}));
/** Enums. */
export var ParkingState;
(function (ParkingState) {
    ParkingState["Free"] = "FREE";
    ParkingState["Full"] = "FULL";
    ParkingState["Unavailable"] = "UNAVAILABLE";
})(ParkingState || (ParkingState = {}));
/** Enums. */
export var ParkingStatus;
(function (ParkingStatus) {
    ParkingStatus["Active"] = "ACTIVE";
    /** @deprecated Bridge for legacy 'disabled' rows; remove after deploy. */
    ParkingStatus["Disabled"] = "DISABLED";
    ParkingStatus["Draft"] = "DRAFT";
    ParkingStatus["Paused"] = "PAUSED";
    ParkingStatus["PendingVerification"] = "PENDING_VERIFICATION";
    ParkingStatus["RejectedVerification"] = "REJECTED_VERIFICATION";
    ParkingStatus["Suspended"] = "SUSPENDED";
})(ParkingStatus || (ParkingStatus = {}));
/** Enums. */
export var PaymentCurrency;
(function (PaymentCurrency) {
    PaymentCurrency["Eur"] = "EUR";
    PaymentCurrency["Pln"] = "PLN";
})(PaymentCurrency || (PaymentCurrency = {}));
/** Enums. */
export var PaymentDirection;
(function (PaymentDirection) {
    PaymentDirection["Charge"] = "CHARGE";
    PaymentDirection["Correction"] = "CORRECTION";
})(PaymentDirection || (PaymentDirection = {}));
/** Enums. */
export var PaymentDocumentStatus;
(function (PaymentDocumentStatus) {
    PaymentDocumentStatus["Generated"] = "GENERATED";
    PaymentDocumentStatus["Issued"] = "ISSUED";
    PaymentDocumentStatus["Sent"] = "SENT";
})(PaymentDocumentStatus || (PaymentDocumentStatus = {}));
/** Enums. */
export var PaymentDocumentType;
(function (PaymentDocumentType) {
    PaymentDocumentType["Confirmation"] = "CONFIRMATION";
    PaymentDocumentType["Invoice"] = "INVOICE";
    PaymentDocumentType["Receipt"] = "RECEIPT";
})(PaymentDocumentType || (PaymentDocumentType = {}));
/** Enums. */
export var PaymentGateway;
(function (PaymentGateway) {
    PaymentGateway["Balance"] = "BALANCE";
    PaymentGateway["Fake"] = "FAKE";
    PaymentGateway["Paynow"] = "PAYNOW";
    PaymentGateway["Tpay"] = "TPAY";
})(PaymentGateway || (PaymentGateway = {}));
/** Enums. */
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["Blik"] = "BLIK";
    PaymentMethod["BlikWithoutCode"] = "BLIK_WITHOUT_CODE";
    PaymentMethod["Redirect"] = "REDIRECT";
    PaymentMethod["Wallet"] = "WALLET";
})(PaymentMethod || (PaymentMethod = {}));
/** Enums. */
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["Failed"] = "FAILED";
    PaymentStatus["Pending"] = "PENDING";
    PaymentStatus["Refunded"] = "REFUNDED";
    PaymentStatus["Succeeded"] = "SUCCEEDED";
})(PaymentStatus || (PaymentStatus = {}));
/** Enums. */
export var PdfPaperFormat;
(function (PdfPaperFormat) {
    PdfPaperFormat["A3"] = "A3";
    PdfPaperFormat["A4"] = "A4";
    PdfPaperFormat["A5"] = "A5";
    PdfPaperFormat["A6"] = "A6";
    PdfPaperFormat["B1"] = "B1";
    PdfPaperFormat["B2"] = "B2";
    PdfPaperFormat["B3"] = "B3";
    PdfPaperFormat["B4"] = "B4";
    PdfPaperFormat["B5"] = "B5";
    PdfPaperFormat["Format_250X250"] = "FORMAT_250X250";
    PdfPaperFormat["Format_350X350"] = "FORMAT_350X350";
    PdfPaperFormat["Format_500X500"] = "FORMAT_500X500";
    PdfPaperFormat["Format_1000X1000"] = "FORMAT_1000X1000";
    PdfPaperFormat["Format_1000X1500"] = "FORMAT_1000X1500";
    PdfPaperFormat["Format_1000X2000"] = "FORMAT_1000X2000";
})(PdfPaperFormat || (PdfPaperFormat = {}));
/** Enums. */
export var PdfPaperOrientation;
(function (PdfPaperOrientation) {
    PdfPaperOrientation["Landscape"] = "LANDSCAPE";
    PdfPaperOrientation["Portrait"] = "PORTRAIT";
})(PdfPaperOrientation || (PdfPaperOrientation = {}));
/** Enums. */
export var PermissionResponseMessage;
(function (PermissionResponseMessage) {
    PermissionResponseMessage["ExceedsOwnAccess"] = "EXCEEDS_OWN_ACCESS";
    PermissionResponseMessage["RoleActivated"] = "ROLE_ACTIVATED";
    PermissionResponseMessage["RoleAlreadyGranted"] = "ROLE_ALREADY_GRANTED";
    PermissionResponseMessage["RoleDeactivated"] = "ROLE_DEACTIVATED";
    PermissionResponseMessage["RoleDerived"] = "ROLE_DERIVED";
    PermissionResponseMessage["RoleExpired"] = "ROLE_EXPIRED";
    PermissionResponseMessage["RoleGranted"] = "ROLE_GRANTED";
    PermissionResponseMessage["RoleNotDeclared"] = "ROLE_NOT_DECLARED";
    PermissionResponseMessage["RoleNotGranted"] = "ROLE_NOT_GRANTED";
    PermissionResponseMessage["RoleOutsideItsScope"] = "ROLE_OUTSIDE_ITS_SCOPE";
    PermissionResponseMessage["RoleRevoked"] = "ROLE_REVOKED";
})(PermissionResponseMessage || (PermissionResponseMessage = {}));
/** Enums. */
export var PermissionResponseStatus;
(function (PermissionResponseStatus) {
    PermissionResponseStatus["Failure"] = "FAILURE";
    PermissionResponseStatus["Success"] = "SUCCESS";
})(PermissionResponseStatus || (PermissionResponseStatus = {}));
/** Enums. */
export var PermissionScope;
(function (PermissionScope) {
    PermissionScope["Organization"] = "ORGANIZATION";
    PermissionScope["Parking"] = "PARKING";
    PermissionScope["System"] = "SYSTEM";
    PermissionScope["User"] = "USER";
})(PermissionScope || (PermissionScope = {}));
/** Enums. */
export var PricePeriod;
(function (PricePeriod) {
    PricePeriod["FourteenDays"] = "FOURTEEN_DAYS";
    PricePeriod["OneHour"] = "ONE_HOUR";
    PricePeriod["Overnight"] = "OVERNIGHT";
    PricePeriod["SameDay"] = "SAME_DAY";
    PricePeriod["SevenDays"] = "SEVEN_DAYS";
    PricePeriod["TwentyEightDays"] = "TWENTY_EIGHT_DAYS";
    PricePeriod["TwentyFourHours"] = "TWENTY_FOUR_HOURS";
    PricePeriod["Weekend"] = "WEEKEND";
})(PricePeriod || (PricePeriod = {}));
/** Enums. */
export var PricePlanScope;
(function (PricePlanScope) {
    PricePlanScope["External"] = "EXTERNAL";
    PricePlanScope["Internal"] = "INTERNAL";
})(PricePlanScope || (PricePlanScope = {}));
/** Enums. */
export var PricePlanStatus;
(function (PricePlanStatus) {
    PricePlanStatus["Active"] = "ACTIVE";
    PricePlanStatus["Archived"] = "ARCHIVED";
    PricePlanStatus["Draft"] = "DRAFT";
    PricePlanStatus["Expired"] = "EXPIRED";
    PricePlanStatus["Pending"] = "PENDING";
})(PricePlanStatus || (PricePlanStatus = {}));
/** Enums. */
export var PriceRulePeriod;
(function (PriceRulePeriod) {
    PriceRulePeriod["FourteenDays"] = "FOURTEEN_DAYS";
    PriceRulePeriod["OneHour"] = "ONE_HOUR";
    PriceRulePeriod["Overnight"] = "OVERNIGHT";
    PriceRulePeriod["SameDay"] = "SAME_DAY";
    PriceRulePeriod["SevenDays"] = "SEVEN_DAYS";
    PriceRulePeriod["TwentyEightDays"] = "TWENTY_EIGHT_DAYS";
    PriceRulePeriod["TwentyFourHours"] = "TWENTY_FOUR_HOURS";
    PriceRulePeriod["Weekend"] = "WEEKEND";
})(PriceRulePeriod || (PriceRulePeriod = {}));
/** Enums. */
export var PriceRuleStatus;
(function (PriceRuleStatus) {
    PriceRuleStatus["Active"] = "ACTIVE";
    PriceRuleStatus["Inactive"] = "INACTIVE";
})(PriceRuleStatus || (PriceRuleStatus = {}));
/** Allowed column names for Query.addresses.orderBy. */
export var QueryAddressesOrderByColumn;
(function (QueryAddressesOrderByColumn) {
    QueryAddressesOrderByColumn["CreatedAt"] = "CREATED_AT";
})(QueryAddressesOrderByColumn || (QueryAddressesOrderByColumn = {}));
/** Allowed column names for Query.adminTickets.orderBy. */
export var QueryAdminTicketsOrderByColumn;
(function (QueryAdminTicketsOrderByColumn) {
    QueryAdminTicketsOrderByColumn["AssignedAt"] = "ASSIGNED_AT";
    QueryAdminTicketsOrderByColumn["CreatedAt"] = "CREATED_AT";
    QueryAdminTicketsOrderByColumn["ResolvedAt"] = "RESOLVED_AT";
    QueryAdminTicketsOrderByColumn["UpdatedAt"] = "UPDATED_AT";
})(QueryAdminTicketsOrderByColumn || (QueryAdminTicketsOrderByColumn = {}));
/** Allowed column names for Query.bankAccounts.orderBy. */
export var QueryBankAccountsOrderByColumn;
(function (QueryBankAccountsOrderByColumn) {
    QueryBankAccountsOrderByColumn["CreatedAt"] = "CREATED_AT";
    QueryBankAccountsOrderByColumn["IsDefault"] = "IS_DEFAULT";
    QueryBankAccountsOrderByColumn["Name"] = "NAME";
    QueryBankAccountsOrderByColumn["UpdatedAt"] = "UPDATED_AT";
    QueryBankAccountsOrderByColumn["VerifiedAt"] = "VERIFIED_AT";
})(QueryBankAccountsOrderByColumn || (QueryBankAccountsOrderByColumn = {}));
/** Allowed column names for Query.billings.orderBy. */
export var QueryBillingsOrderByColumn;
(function (QueryBillingsOrderByColumn) {
    QueryBillingsOrderByColumn["AccruedBalance"] = "ACCRUED_BALANCE";
    QueryBillingsOrderByColumn["AvailableBalance"] = "AVAILABLE_BALANCE";
    QueryBillingsOrderByColumn["ControllerAgreement"] = "CONTROLLER_AGREEMENT";
    QueryBillingsOrderByColumn["CreatedAt"] = "CREATED_AT";
    QueryBillingsOrderByColumn["IsDefault"] = "IS_DEFAULT";
    QueryBillingsOrderByColumn["Name"] = "NAME";
    QueryBillingsOrderByColumn["PaidOutBalance"] = "PAID_OUT_BALANCE";
    QueryBillingsOrderByColumn["Type"] = "TYPE";
    QueryBillingsOrderByColumn["UpdatedAt"] = "UPDATED_AT";
    QueryBillingsOrderByColumn["VerifiedAt"] = "VERIFIED_AT";
})(QueryBillingsOrderByColumn || (QueryBillingsOrderByColumn = {}));
/** Allowed column names for Query.cities.orderBy. */
export var QueryCitiesOrderByColumn;
(function (QueryCitiesOrderByColumn) {
    QueryCitiesOrderByColumn["CreatedAt"] = "CREATED_AT";
})(QueryCitiesOrderByColumn || (QueryCitiesOrderByColumn = {}));
/** Allowed column names for Query.images.orderBy. */
export var QueryImagesOrderByColumn;
(function (QueryImagesOrderByColumn) {
    QueryImagesOrderByColumn["Position"] = "POSITION";
})(QueryImagesOrderByColumn || (QueryImagesOrderByColumn = {}));
/** Allowed column names for Query.integrationEvents.orderBy. */
export var QueryIntegrationEventsOrderByColumn;
(function (QueryIntegrationEventsOrderByColumn) {
    QueryIntegrationEventsOrderByColumn["Attempts"] = "ATTEMPTS";
    QueryIntegrationEventsOrderByColumn["CreatedAt"] = "CREATED_AT";
    QueryIntegrationEventsOrderByColumn["EventName"] = "EVENT_NAME";
    QueryIntegrationEventsOrderByColumn["ProcessedAt"] = "PROCESSED_AT";
})(QueryIntegrationEventsOrderByColumn || (QueryIntegrationEventsOrderByColumn = {}));
/** Allowed column names for Query.memberships.orderBy. */
export var QueryMembershipsOrderByColumn;
(function (QueryMembershipsOrderByColumn) {
    QueryMembershipsOrderByColumn["CreatedAt"] = "CREATED_AT";
})(QueryMembershipsOrderByColumn || (QueryMembershipsOrderByColumn = {}));
/** Allowed column names for Query.orders.orderBy. */
export var QueryOrdersOrderByColumn;
(function (QueryOrdersOrderByColumn) {
    QueryOrdersOrderByColumn["Category"] = "CATEGORY";
    QueryOrdersOrderByColumn["CreatedAt"] = "CREATED_AT";
    QueryOrdersOrderByColumn["Direction"] = "DIRECTION";
    QueryOrdersOrderByColumn["GrossAmount"] = "GROSS_AMOUNT";
    QueryOrdersOrderByColumn["NetAmount"] = "NET_AMOUNT";
    QueryOrdersOrderByColumn["Number"] = "NUMBER";
    QueryOrdersOrderByColumn["Product"] = "PRODUCT";
    QueryOrdersOrderByColumn["Status"] = "STATUS";
    QueryOrdersOrderByColumn["UpdatedAt"] = "UPDATED_AT";
})(QueryOrdersOrderByColumn || (QueryOrdersOrderByColumn = {}));
/** Allowed column names for Query.organizations.orderBy. */
export var QueryOrganizationsOrderByColumn;
(function (QueryOrganizationsOrderByColumn) {
    QueryOrganizationsOrderByColumn["CreatedAt"] = "CREATED_AT";
})(QueryOrganizationsOrderByColumn || (QueryOrganizationsOrderByColumn = {}));
/** Allowed column names for Query.parkingPoints.orderBy. */
export var QueryParkingPointsOrderByColumn;
(function (QueryParkingPointsOrderByColumn) {
    QueryParkingPointsOrderByColumn["CreatedAt"] = "CREATED_AT";
    QueryParkingPointsOrderByColumn["Id"] = "ID";
    QueryParkingPointsOrderByColumn["NodeIndex"] = "NODE_INDEX";
    QueryParkingPointsOrderByColumn["PathIndex"] = "PATH_INDEX";
    QueryParkingPointsOrderByColumn["Type"] = "TYPE";
    QueryParkingPointsOrderByColumn["UpdatedAt"] = "UPDATED_AT";
})(QueryParkingPointsOrderByColumn || (QueryParkingPointsOrderByColumn = {}));
/** Allowed column names for Query.parkingReservationSpans.orderBy. */
export var QueryParkingReservationSpansOrderByColumn;
(function (QueryParkingReservationSpansOrderByColumn) {
    QueryParkingReservationSpansOrderByColumn["EndsAt"] = "ENDS_AT";
    QueryParkingReservationSpansOrderByColumn["StartsAt"] = "STARTS_AT";
})(QueryParkingReservationSpansOrderByColumn || (QueryParkingReservationSpansOrderByColumn = {}));
/** Allowed column names for Query.parkings.orderBy. */
export var QueryParkingsOrderByColumn;
(function (QueryParkingsOrderByColumn) {
    QueryParkingsOrderByColumn["CreatedAt"] = "CREATED_AT";
    QueryParkingsOrderByColumn["HasSignage"] = "HAS_SIGNAGE";
    QueryParkingsOrderByColumn["Height"] = "HEIGHT";
    QueryParkingsOrderByColumn["Identifier"] = "IDENTIFIER";
    QueryParkingsOrderByColumn["Length"] = "LENGTH";
    QueryParkingsOrderByColumn["LotMode"] = "LOT_MODE";
    QueryParkingsOrderByColumn["MaxVehicleWeight"] = "MAX_VEHICLE_WEIGHT";
    QueryParkingsOrderByColumn["Name"] = "NAME";
    QueryParkingsOrderByColumn["State"] = "STATE";
    QueryParkingsOrderByColumn["Status"] = "STATUS";
    QueryParkingsOrderByColumn["UpdatedAt"] = "UPDATED_AT";
    QueryParkingsOrderByColumn["Width"] = "WIDTH";
})(QueryParkingsOrderByColumn || (QueryParkingsOrderByColumn = {}));
/** Allowed column names for Query.paymentDocuments.orderBy. */
export var QueryPaymentDocumentsOrderByColumn;
(function (QueryPaymentDocumentsOrderByColumn) {
    QueryPaymentDocumentsOrderByColumn["CreatedAt"] = "CREATED_AT";
    QueryPaymentDocumentsOrderByColumn["GrossAmount"] = "GROSS_AMOUNT";
    QueryPaymentDocumentsOrderByColumn["IssuedOn"] = "ISSUED_ON";
    QueryPaymentDocumentsOrderByColumn["NetAmount"] = "NET_AMOUNT";
    QueryPaymentDocumentsOrderByColumn["Number"] = "NUMBER";
    QueryPaymentDocumentsOrderByColumn["Status"] = "STATUS";
    QueryPaymentDocumentsOrderByColumn["VatAmount"] = "VAT_AMOUNT";
})(QueryPaymentDocumentsOrderByColumn || (QueryPaymentDocumentsOrderByColumn = {}));
/** Allowed column names for Query.payments.orderBy. */
export var QueryPaymentsOrderByColumn;
(function (QueryPaymentsOrderByColumn) {
    QueryPaymentsOrderByColumn["Amount"] = "AMOUNT";
    QueryPaymentsOrderByColumn["CreatedAt"] = "CREATED_AT";
    QueryPaymentsOrderByColumn["Direction"] = "DIRECTION";
    QueryPaymentsOrderByColumn["Gateway"] = "GATEWAY";
    QueryPaymentsOrderByColumn["Id"] = "ID";
    QueryPaymentsOrderByColumn["Method"] = "METHOD";
    QueryPaymentsOrderByColumn["Status"] = "STATUS";
    QueryPaymentsOrderByColumn["UpdatedAt"] = "UPDATED_AT";
})(QueryPaymentsOrderByColumn || (QueryPaymentsOrderByColumn = {}));
/** Allowed column names for Query.pilots.orderBy. */
export var QueryPilotsOrderByColumn;
(function (QueryPilotsOrderByColumn) {
    QueryPilotsOrderByColumn["CreatedAt"] = "CREATED_AT";
})(QueryPilotsOrderByColumn || (QueryPilotsOrderByColumn = {}));
/** Allowed column names for Query.plannedNotifications.orderBy. */
export var QueryPlannedNotificationsOrderByColumn;
(function (QueryPlannedNotificationsOrderByColumn) {
    QueryPlannedNotificationsOrderByColumn["SendAt"] = "SEND_AT";
})(QueryPlannedNotificationsOrderByColumn || (QueryPlannedNotificationsOrderByColumn = {}));
/** Allowed column names for Query.pricePlans.orderBy. */
export var QueryPricePlansOrderByColumn;
(function (QueryPricePlansOrderByColumn) {
    QueryPricePlansOrderByColumn["CreatedAt"] = "CREATED_AT";
})(QueryPricePlansOrderByColumn || (QueryPricePlansOrderByColumn = {}));
/** Allowed column names for Query.priceRules.orderBy. */
export var QueryPriceRulesOrderByColumn;
(function (QueryPriceRulesOrderByColumn) {
    QueryPriceRulesOrderByColumn["CreatedAt"] = "CREATED_AT";
})(QueryPriceRulesOrderByColumn || (QueryPriceRulesOrderByColumn = {}));
/** Allowed column names for Query.relatedTickets.orderBy. */
export var QueryRelatedTicketsOrderByColumn;
(function (QueryRelatedTicketsOrderByColumn) {
    QueryRelatedTicketsOrderByColumn["CreatedAt"] = "CREATED_AT";
})(QueryRelatedTicketsOrderByColumn || (QueryRelatedTicketsOrderByColumn = {}));
/** Allowed column names for Query.reservationsByRegistrationNumber.orderBy. */
export var QueryReservationsByRegistrationNumberOrderByColumn;
(function (QueryReservationsByRegistrationNumberOrderByColumn) {
    QueryReservationsByRegistrationNumberOrderByColumn["CreatedAt"] = "CREATED_AT";
    QueryReservationsByRegistrationNumberOrderByColumn["StartAt"] = "START_AT";
})(QueryReservationsByRegistrationNumberOrderByColumn || (QueryReservationsByRegistrationNumberOrderByColumn = {}));
/** Allowed column names for Query.reservations.orderBy. */
export var QueryReservationsOrderByColumn;
(function (QueryReservationsOrderByColumn) {
    QueryReservationsOrderByColumn["ConfirmedAt"] = "CONFIRMED_AT";
    QueryReservationsOrderByColumn["CreatedAt"] = "CREATED_AT";
    QueryReservationsOrderByColumn["ExpiresAt"] = "EXPIRES_AT";
    QueryReservationsOrderByColumn["Number"] = "NUMBER";
    QueryReservationsOrderByColumn["StartsAt"] = "STARTS_AT";
    QueryReservationsOrderByColumn["Status"] = "STATUS";
    QueryReservationsOrderByColumn["Type"] = "TYPE";
    QueryReservationsOrderByColumn["UpdatedAt"] = "UPDATED_AT";
})(QueryReservationsOrderByColumn || (QueryReservationsOrderByColumn = {}));
/** Allowed column names for Query.salesDocuments.orderBy. */
export var QuerySalesDocumentsOrderByColumn;
(function (QuerySalesDocumentsOrderByColumn) {
    QuerySalesDocumentsOrderByColumn["CreatedAt"] = "CREATED_AT";
    QuerySalesDocumentsOrderByColumn["GrossAmount"] = "GROSS_AMOUNT";
    QuerySalesDocumentsOrderByColumn["IssuedOn"] = "ISSUED_ON";
    QuerySalesDocumentsOrderByColumn["Number"] = "NUMBER";
})(QuerySalesDocumentsOrderByColumn || (QuerySalesDocumentsOrderByColumn = {}));
/** Allowed column names for Query.shopOrders.orderBy. */
export var QueryShopOrdersOrderByColumn;
(function (QueryShopOrdersOrderByColumn) {
    QueryShopOrdersOrderByColumn["CreatedAt"] = "CREATED_AT";
    QueryShopOrdersOrderByColumn["GrossAmount"] = "GROSS_AMOUNT";
    QueryShopOrdersOrderByColumn["Id"] = "ID";
    QueryShopOrdersOrderByColumn["Number"] = "NUMBER";
    QueryShopOrdersOrderByColumn["PaidAt"] = "PAID_AT";
    QueryShopOrdersOrderByColumn["PlacedAt"] = "PLACED_AT";
    QueryShopOrdersOrderByColumn["Status"] = "STATUS";
})(QueryShopOrdersOrderByColumn || (QueryShopOrdersOrderByColumn = {}));
/** Allowed column names for Query.signs.orderBy. */
export var QuerySignsOrderByColumn;
(function (QuerySignsOrderByColumn) {
    QuerySignsOrderByColumn["CreatedAt"] = "CREATED_AT";
})(QuerySignsOrderByColumn || (QuerySignsOrderByColumn = {}));
/** Allowed column names for Query.spots.orderBy. */
export var QuerySpotsOrderByColumn;
(function (QuerySpotsOrderByColumn) {
    QuerySpotsOrderByColumn["CreatedAt"] = "CREATED_AT";
})(QuerySpotsOrderByColumn || (QuerySpotsOrderByColumn = {}));
/** Allowed column names for Query.systemControllers.orderBy. */
export var QuerySystemControllersOrderByColumn;
(function (QuerySystemControllersOrderByColumn) {
    QuerySystemControllersOrderByColumn["CreatedAt"] = "CREATED_AT";
    QuerySystemControllersOrderByColumn["OperationRegion"] = "OPERATION_REGION";
    QuerySystemControllersOrderByColumn["Status"] = "STATUS";
    QuerySystemControllersOrderByColumn["UpdatedAt"] = "UPDATED_AT";
})(QuerySystemControllersOrderByColumn || (QuerySystemControllersOrderByColumn = {}));
/** Allowed column names for Query.tickets.orderBy. */
export var QueryTicketsOrderByColumn;
(function (QueryTicketsOrderByColumn) {
    QueryTicketsOrderByColumn["CreatedAt"] = "CREATED_AT";
})(QueryTicketsOrderByColumn || (QueryTicketsOrderByColumn = {}));
/** Allowed column names for Query.unavailabilityRules.orderBy. */
export var QueryUnavailabilityRulesOrderByColumn;
(function (QueryUnavailabilityRulesOrderByColumn) {
    QueryUnavailabilityRulesOrderByColumn["CreatedAt"] = "CREATED_AT";
})(QueryUnavailabilityRulesOrderByColumn || (QueryUnavailabilityRulesOrderByColumn = {}));
/** Allowed column names for Query.userVehicles.orderBy. */
export var QueryUserVehiclesOrderByColumn;
(function (QueryUserVehiclesOrderByColumn) {
    QueryUserVehiclesOrderByColumn["CreatedAt"] = "CREATED_AT";
    QueryUserVehiclesOrderByColumn["IsPrimary"] = "IS_PRIMARY";
})(QueryUserVehiclesOrderByColumn || (QueryUserVehiclesOrderByColumn = {}));
/** Allowed column names for Query.users.orderBy. */
export var QueryUsersOrderByColumn;
(function (QueryUsersOrderByColumn) {
    QueryUsersOrderByColumn["CreatedAt"] = "CREATED_AT";
    QueryUsersOrderByColumn["Email"] = "EMAIL";
    QueryUsersOrderByColumn["LastSeenAt"] = "LAST_SEEN_AT";
    QueryUsersOrderByColumn["Name"] = "NAME";
})(QueryUsersOrderByColumn || (QueryUsersOrderByColumn = {}));
/** Allowed column names for Query.walletTransactions.orderBy. */
export var QueryWalletTransactionsOrderByColumn;
(function (QueryWalletTransactionsOrderByColumn) {
    QueryWalletTransactionsOrderByColumn["Amount"] = "AMOUNT";
    QueryWalletTransactionsOrderByColumn["Balance"] = "BALANCE";
    QueryWalletTransactionsOrderByColumn["CreatedAt"] = "CREATED_AT";
    QueryWalletTransactionsOrderByColumn["Type"] = "TYPE";
})(QueryWalletTransactionsOrderByColumn || (QueryWalletTransactionsOrderByColumn = {}));
/** Allowed column names for Query.wallets.orderBy. */
export var QueryWalletsOrderByColumn;
(function (QueryWalletsOrderByColumn) {
    QueryWalletsOrderByColumn["Balance"] = "BALANCE";
    QueryWalletsOrderByColumn["CreatedAt"] = "CREATED_AT";
    QueryWalletsOrderByColumn["UpdatedAt"] = "UPDATED_AT";
})(QueryWalletsOrderByColumn || (QueryWalletsOrderByColumn = {}));
/** Enums. */
export var ReassignReservationReason;
(function (ReassignReservationReason) {
    /** An operator decided to move the span. */
    ReassignReservationReason["Administrative"] = "ADMINISTRATIVE";
    /** The spot cannot be used: damaged, blocked or under maintenance. */
    ReassignReservationReason["SpotUnavailable"] = "SPOT_UNAVAILABLE";
    /** The spot is taken by somebody without a reservation. */
    ReassignReservationReason["UnauthorizedOccupation"] = "UNAUTHORIZED_OCCUPATION";
})(ReassignReservationReason || (ReassignReservationReason = {}));
/**
 * Enums.
 *
 * What a control of a registration number on a parking finds: the vehicle may park there, it may not, or it may
 * not and is already reported there today, so it is not punished again.
 */
export var RegistrationNumberControlStatus;
(function (RegistrationNumberControlStatus) {
    RegistrationNumberControlStatus["Allowed"] = "ALLOWED";
    RegistrationNumberControlStatus["NotAllowed"] = "NOT_ALLOWED";
    RegistrationNumberControlStatus["Reported"] = "REPORTED";
})(RegistrationNumberControlStatus || (RegistrationNumberControlStatus = {}));
/** The resend email verification statuses. */
export var ResendEmailVerificationStatus;
(function (ResendEmailVerificationStatus) {
    /** The sent email status. */
    ResendEmailVerificationStatus["EmailSent"] = "EMAIL_SENT";
})(ResendEmailVerificationStatus || (ResendEmailVerificationStatus = {}));
/** Enums. */
export var ReservationResponseMessage;
(function (ReservationResponseMessage) {
    ReservationResponseMessage["BillingNotFound"] = "BILLING_NOT_FOUND";
    ReservationResponseMessage["BillingOwnershipMismatch"] = "BILLING_OWNERSHIP_MISMATCH";
    ReservationResponseMessage["ExtensionAvailable"] = "EXTENSION_AVAILABLE";
    ReservationResponseMessage["FutureReservationUnavailable"] = "FUTURE_RESERVATION_UNAVAILABLE";
    ReservationResponseMessage["NoAvailableSpot"] = "NO_AVAILABLE_SPOT";
    ReservationResponseMessage["Other"] = "OTHER";
    ReservationResponseMessage["ParkingNotFound"] = "PARKING_NOT_FOUND";
    ReservationResponseMessage["PaymentFailed"] = "PAYMENT_FAILED";
    ReservationResponseMessage["PendingExtensionExists"] = "PENDING_EXTENSION_EXISTS";
    ReservationResponseMessage["PendingReservationExists"] = "PENDING_RESERVATION_EXISTS";
    ReservationResponseMessage["PriceEstimated"] = "PRICE_ESTIMATED";
    ReservationResponseMessage["ReservationLastVehicle"] = "RESERVATION_LAST_VEHICLE";
    ReservationResponseMessage["ReservationLockExpired"] = "RESERVATION_LOCK_EXPIRED";
    ReservationResponseMessage["ReservationNotFound"] = "RESERVATION_NOT_FOUND";
    ReservationResponseMessage["ReservationNotPending"] = "RESERVATION_NOT_PENDING";
    ReservationResponseMessage["ReservationOwnershipMismatch"] = "RESERVATION_OWNERSHIP_MISMATCH";
    ReservationResponseMessage["ReservationRegistrationNumberAlreadyAdded"] = "RESERVATION_REGISTRATION_NUMBER_ALREADY_ADDED";
    ReservationResponseMessage["ReservationSpanNotFound"] = "RESERVATION_SPAN_NOT_FOUND";
    ReservationResponseMessage["ReservationSpanNotReassignable"] = "RESERVATION_SPAN_NOT_REASSIGNABLE";
    ReservationResponseMessage["ReservationUserAlreadyAssigned"] = "RESERVATION_USER_ALREADY_ASSIGNED";
    ReservationResponseMessage["ReservationVehicleLimitReached"] = "RESERVATION_VEHICLE_LIMIT_REACHED";
    ReservationResponseMessage["ReservationVehicleMissing"] = "RESERVATION_VEHICLE_MISSING";
    ReservationResponseMessage["ReservationVehicleSealed"] = "RESERVATION_VEHICLE_SEALED";
    ReservationResponseMessage["ReservationVehicleStatusNotAllowed"] = "RESERVATION_VEHICLE_STATUS_NOT_ALLOWED";
    ReservationResponseMessage["Reserved"] = "RESERVED";
    ReservationResponseMessage["RevolvingPeriodUnavailable"] = "REVOLVING_PERIOD_UNAVAILABLE";
    ReservationResponseMessage["SpotNotFound"] = "SPOT_NOT_FOUND";
    ReservationResponseMessage["SpotReassigned"] = "SPOT_REASSIGNED";
    ReservationResponseMessage["SpotTaken"] = "SPOT_TAKEN";
    ReservationResponseMessage["StepCompleted"] = "STEP_COMPLETED";
    ReservationResponseMessage["VehicleNotFound"] = "VEHICLE_NOT_FOUND";
    ReservationResponseMessage["VehicleOwnershipMismatch"] = "VEHICLE_OWNERSHIP_MISMATCH";
    ReservationResponseMessage["WaitingForPayment"] = "WAITING_FOR_PAYMENT";
})(ReservationResponseMessage || (ReservationResponseMessage = {}));
/** Enums. */
export var ReservationResponseStatus;
(function (ReservationResponseStatus) {
    ReservationResponseStatus["Failure"] = "FAILURE";
    ReservationResponseStatus["Success"] = "SUCCESS";
})(ReservationResponseStatus || (ReservationResponseStatus = {}));
/** Enums. */
export var ReservationSpanPaymentLinkStatus;
(function (ReservationSpanPaymentLinkStatus) {
    ReservationSpanPaymentLinkStatus["Paid"] = "PAID";
    ReservationSpanPaymentLinkStatus["Payable"] = "PAYABLE";
})(ReservationSpanPaymentLinkStatus || (ReservationSpanPaymentLinkStatus = {}));
/** Enums. */
export var ReservationSpanStatus;
(function (ReservationSpanStatus) {
    ReservationSpanStatus["Active"] = "ACTIVE";
    ReservationSpanStatus["Canceled"] = "CANCELED";
    ReservationSpanStatus["Completed"] = "COMPLETED";
    ReservationSpanStatus["Pending"] = "PENDING";
    ReservationSpanStatus["Scheduled"] = "SCHEDULED";
})(ReservationSpanStatus || (ReservationSpanStatus = {}));
/** Enums. */
export var ReservationStatus;
(function (ReservationStatus) {
    ReservationStatus["Active"] = "ACTIVE";
    ReservationStatus["Canceled"] = "CANCELED";
    ReservationStatus["Completed"] = "COMPLETED";
    ReservationStatus["Confirmed"] = "CONFIRMED";
    ReservationStatus["Expired"] = "EXPIRED";
    ReservationStatus["Pending"] = "PENDING";
})(ReservationStatus || (ReservationStatus = {}));
/** Enums. */
export var ReservationType;
(function (ReservationType) {
    ReservationType["OneTime"] = "ONE_TIME";
    ReservationType["Recurring"] = "RECURRING";
})(ReservationType || (ReservationType = {}));
/** The reset password statuses. */
export var ResetPasswordStatus;
(function (ResetPasswordStatus) {
    /** The reset password status. */
    ResetPasswordStatus["PasswordReset"] = "PASSWORD_RESET";
})(ResetPasswordStatus || (ResetPasswordStatus = {}));
/** Enums. */
export var Resource;
(function (Resource) {
    Resource["Activity"] = "ACTIVITY";
    Resource["Address"] = "ADDRESS";
    Resource["AuthorizationCode"] = "AUTHORIZATION_CODE";
    Resource["BankAccount"] = "BANK_ACCOUNT";
    Resource["Billing"] = "BILLING";
    Resource["Button"] = "BUTTON";
    Resource["Image"] = "IMAGE";
    Resource["Invitation"] = "INVITATION";
    Resource["Membership"] = "MEMBERSHIP";
    Resource["OpeningHour"] = "OPENING_HOUR";
    Resource["Order"] = "ORDER";
    Resource["Organization"] = "ORGANIZATION";
    Resource["Parking"] = "PARKING";
    Resource["Partner"] = "PARTNER";
    Resource["Payment"] = "PAYMENT";
    Resource["PaymentDocument"] = "PAYMENT_DOCUMENT";
    Resource["Pilot"] = "PILOT";
    /** @deprecated ... */
    Resource["Price"] = "PRICE";
    Resource["PricePlan"] = "PRICE_PLAN";
    Resource["PriceRule"] = "PRICE_RULE";
    Resource["Reservation"] = "RESERVATION";
    Resource["Sign"] = "SIGN";
    Resource["Spot"] = "SPOT";
    Resource["Tag"] = "TAG";
    Resource["Ticket"] = "TICKET";
    Resource["TicketMessage"] = "TICKET_MESSAGE";
    Resource["Token"] = "TOKEN";
    Resource["Transaction"] = "TRANSACTION";
    Resource["UnavailabilityPlan"] = "UNAVAILABILITY_PLAN";
    Resource["UnavailabilityRule"] = "UNAVAILABILITY_RULE";
    Resource["User"] = "USER";
    Resource["Vehicle"] = "VEHICLE";
    Resource["Verification"] = "VERIFICATION";
    Resource["Wallet"] = "WALLET";
    Resource["WalletTransaction"] = "WALLET_TRANSACTION";
    Resource["Withdrawal"] = "WITHDRAWAL";
})(Resource || (Resource = {}));
/**
 * Enums.
 *
 * What a sales document is issued for: a shop order, a parking operation (a reservation), or nothing the system
 * knows, when an operator issues it by hand.
 */
export var SalesDocumentSource;
(function (SalesDocumentSource) {
    SalesDocumentSource["Manual"] = "MANUAL";
    SalesDocumentSource["ParkingOperation"] = "PARKING_OPERATION";
    SalesDocumentSource["ShopOrder"] = "SHOP_ORDER";
})(SalesDocumentSource || (SalesDocumentSource = {}));
/**
 * Enums.
 *
 * The kinds of sales documents: an invoice for a buyer with a VAT number, a receipt for anybody else.
 */
export var SalesDocumentType;
(function (SalesDocumentType) {
    SalesDocumentType["Invoice"] = "INVOICE";
    SalesDocumentType["Receipt"] = "RECEIPT";
})(SalesDocumentType || (SalesDocumentType = {}));
/** Enums. */
export var ShopCurrency;
(function (ShopCurrency) {
    ShopCurrency["Eur"] = "EUR";
    ShopCurrency["Pln"] = "PLN";
})(ShopCurrency || (ShopCurrency = {}));
/**
 * Enums.
 *
 * The client-safe error codes a domain exception is translated into by the
 * `BusinessRuleViolationErrorHandler`. An exception missing from `fromException()` is treated as an
 * internal server error and reported to Sentry — every new domain exception MUST be registered here,
 * or a business rule the caller could have acted on reaches them as "Internal server error".
 */
export var ShopDomainErrorCode;
(function (ShopDomainErrorCode) {
    ShopDomainErrorCode["AggregateNotFound"] = "AGGREGATE_NOT_FOUND";
    ShopDomainErrorCode["DiscountLineBoundToParking"] = "DISCOUNT_LINE_BOUND_TO_PARKING";
    ShopDomainErrorCode["DuplicateOrderLine"] = "DUPLICATE_ORDER_LINE";
    ShopDomainErrorCode["DuplicateSpotReference"] = "DUPLICATE_SPOT_REFERENCE";
    ShopDomainErrorCode["EmptyOrder"] = "EMPTY_ORDER";
    ShopDomainErrorCode["IllegalOrderStatusTransition"] = "ILLEGAL_ORDER_STATUS_TRANSITION";
    ShopDomainErrorCode["IllegalPaymentStatusTransition"] = "ILLEGAL_PAYMENT_STATUS_TRANSITION";
    ShopDomainErrorCode["InternalPaymentNotRefundable"] = "INTERNAL_PAYMENT_NOT_REFUNDABLE";
    ShopDomainErrorCode["InvalidOrderItemQuantity"] = "INVALID_ORDER_ITEM_QUANTITY";
    ShopDomainErrorCode["InvalidValueObject"] = "INVALID_VALUE_OBJECT";
    ShopDomainErrorCode["NegativeOrderTotal"] = "NEGATIVE_ORDER_TOTAL";
    ShopDomainErrorCode["OrderEmailsAlreadySent"] = "ORDER_EMAILS_ALREADY_SENT";
    ShopDomainErrorCode["OrderPriceMismatch"] = "ORDER_PRICE_MISMATCH";
    ShopDomainErrorCode["PaymentExternalIdAlreadySet"] = "PAYMENT_EXTERNAL_ID_ALREADY_SET";
    ShopDomainErrorCode["PaymentNotRefundable"] = "PAYMENT_NOT_REFUNDABLE";
    ShopDomainErrorCode["SpotBoundQuantityMismatch"] = "SPOT_BOUND_QUANTITY_MISMATCH";
})(ShopDomainErrorCode || (ShopDomainErrorCode = {}));
/**
 * Enums.
 *
 * Who an order e-mail is for. The storefront names the kind and writes the text; the shop alone
 * decides the address, so the kind is the only part of the instruction that routes anything.
 */
export var ShopOrderEmailKind;
(function (ShopOrderEmailKind) {
    ShopOrderEmailKind["Customer"] = "CUSTOMER";
    ShopOrderEmailKind["CustomerAwaitingTransfer"] = "CUSTOMER_AWAITING_TRANSFER";
    ShopOrderEmailKind["MetalProducer"] = "METAL_PRODUCER";
    ShopOrderEmailKind["PvcProducer"] = "PVC_PRODUCER";
    ShopOrderEmailKind["ShopWorker"] = "SHOP_WORKER";
    ShopOrderEmailKind["ShopWorkerAwaitingTransfer"] = "SHOP_WORKER_AWAITING_TRANSFER";
})(ShopOrderEmailKind || (ShopOrderEmailKind = {}));
/**
 * Enums.
 *
 * What an order line stands for. A discount line carries a positive amount like any other line, and
 * its kind — never the sign of its amount — is what makes it lower the order total.
 */
export var ShopOrderItemKind;
(function (ShopOrderItemKind) {
    ShopOrderItemKind["Discount"] = "DISCOUNT";
    ShopOrderItemKind["Product"] = "PRODUCT";
})(ShopOrderItemKind || (ShopOrderItemKind = {}));
/**
 * Enums.
 *
 * The lifecycle of a shop order. The vocabulary deliberately matches the core `OrderStatus`, so a
 * reader of both graphs reads one vocabulary rather than two.
 */
export var ShopOrderStatus;
(function (ShopOrderStatus) {
    ShopOrderStatus["Canceled"] = "CANCELED";
    ShopOrderStatus["Completed"] = "COMPLETED";
    ShopOrderStatus["Fulfilled"] = "FULFILLED";
    ShopOrderStatus["Paid"] = "PAID";
    ShopOrderStatus["Placed"] = "PLACED";
})(ShopOrderStatus || (ShopOrderStatus = {}));
/**
 * Enums.
 *
 * The payment providers the shop can settle an order through. Core's `BALANCE` is deliberately
 * absent: the shop has no wallet. `BankTransfer` is no provider at all: the shopper transfers the
 * money on their own, nothing notifies the shop of it, and staff mark the payment paid. `Internal`
 * is no provider either: ParkApp covers the order itself, staff record it, and no money moves.
 */
export var ShopPaymentGateway;
(function (ShopPaymentGateway) {
    ShopPaymentGateway["BankTransfer"] = "BANK_TRANSFER";
    ShopPaymentGateway["Fake"] = "FAKE";
    ShopPaymentGateway["Internal"] = "INTERNAL";
    ShopPaymentGateway["Paynow"] = "PAYNOW";
    ShopPaymentGateway["Tpay"] = "TPAY";
})(ShopPaymentGateway || (ShopPaymentGateway = {}));
/**
 * Enums.
 *
 * How the shopper pays. Core's `WALLET` is deliberately absent: the shop has no wallet to draw on.
 * `Internal` is no way a shopper can choose: ParkApp covers the order itself, staff record it, and
 * the method only marks the payment so it shows and filters like any other.
 */
export var ShopPaymentMethod;
(function (ShopPaymentMethod) {
    ShopPaymentMethod["BankTransfer"] = "BANK_TRANSFER";
    ShopPaymentMethod["Blik"] = "BLIK";
    /** @deprecated No gateway takes a Blik payment without the code any more. Pay by BLIK with the code instead. */
    ShopPaymentMethod["BlikWithoutCode"] = "BLIK_WITHOUT_CODE";
    ShopPaymentMethod["Internal"] = "INTERNAL";
    ShopPaymentMethod["Redirect"] = "REDIRECT";
})(ShopPaymentMethod || (ShopPaymentMethod = {}));
/**
 * Enums.
 *
 * The lifecycle of a payment. The vocabulary matches the core `PaymentStatus`, so a reader of both
 * graphs reads one vocabulary rather than two.
 */
export var ShopPaymentStatus;
(function (ShopPaymentStatus) {
    ShopPaymentStatus["Failed"] = "FAILED";
    ShopPaymentStatus["Pending"] = "PENDING";
    ShopPaymentStatus["Refunded"] = "REFUNDED";
    ShopPaymentStatus["Succeeded"] = "SUCCEEDED";
})(ShopPaymentStatus || (ShopPaymentStatus = {}));
/** Enums. */
export var SignStatus;
(function (SignStatus) {
    SignStatus["Completed"] = "COMPLETED";
    SignStatus["Failed"] = "FAILED";
    SignStatus["Generated"] = "GENERATED";
    SignStatus["Prepared"] = "PREPARED";
})(SignStatus || (SignStatus = {}));
/** Enums. */
export var SignTemplate;
(function (SignTemplate) {
    SignTemplate["Fake"] = "FAKE";
    SignTemplate["MainBlue"] = "MAIN_BLUE";
    SignTemplate["MainBlueSimple"] = "MAIN_BLUE_SIMPLE";
    SignTemplate["MainWhite"] = "MAIN_WHITE";
    SignTemplate["SpotBlue"] = "SPOT_BLUE";
    SignTemplate["SpotBlueQr"] = "SPOT_BLUE_QR";
    SignTemplate["SpotWhite"] = "SPOT_WHITE";
    SignTemplate["SpotWhiteQr"] = "SPOT_WHITE_QR";
    SignTemplate["TermsBlue"] = "TERMS_BLUE";
    SignTemplate["TermsWhite"] = "TERMS_WHITE";
})(SignTemplate || (SignTemplate = {}));
/** Enums. */
export var SignType;
(function (SignType) {
    SignType["Main"] = "MAIN";
    SignType["Spot"] = "SPOT";
    SignType["Terms"] = "TERMS";
})(SignType || (SignType = {}));
/** Directions for ordering a list of records. */
export var SortOrder;
(function (SortOrder) {
    /** Sort records in ascending order. */
    SortOrder["Asc"] = "ASC";
    /** Sort records in descending order. */
    SortOrder["Desc"] = "DESC";
})(SortOrder || (SortOrder = {}));
/** Enums. */
export var SpotProperty;
(function (SpotProperty) {
    SpotProperty["Compact"] = "COMPACT";
    SpotProperty["Covered"] = "COVERED";
    SpotProperty["DisabledAccess"] = "DISABLED_ACCESS";
    SpotProperty["EvChargingAc"] = "EV_CHARGING_AC";
    SpotProperty["EvChargingDc100To200Kw"] = "EV_CHARGING_DC100_TO200KW";
    SpotProperty["EvChargingDc200To300Kw"] = "EV_CHARGING_DC200_TO300KW";
    SpotProperty["EvChargingDc300To400Kw"] = "EV_CHARGING_DC300_TO400KW";
    SpotProperty["EvChargingDcOver400Kw"] = "EV_CHARGING_DC_OVER400KW";
    SpotProperty["EvChargingDcUnder100Kw"] = "EV_CHARGING_DC_UNDER100KW";
    SpotProperty["Lockable"] = "LOCKABLE";
    SpotProperty["LpgFriendly"] = "LPG_FRIENDLY";
    SpotProperty["NoLpg"] = "NO_LPG";
    SpotProperty["Open24H"] = "OPEN24H";
    SpotProperty["Outdoor"] = "OUTDOOR";
    SpotProperty["Secured"] = "SECURED";
    SpotProperty["Shelter"] = "SHELTER";
    SpotProperty["Truck7To12T"] = "TRUCK7_TO12T";
    SpotProperty["TruckOver12T"] = "TRUCK_OVER12T";
    SpotProperty["TruckSemi"] = "TRUCK_SEMI";
    SpotProperty["TruckUnder7T"] = "TRUCK_UNDER7T";
    SpotProperty["XxlSpace"] = "XXL_SPACE";
})(SpotProperty || (SpotProperty = {}));
/** Enums. */
export var SpotState;
(function (SpotState) {
    SpotState["Available"] = "AVAILABLE";
    SpotState["Occupied"] = "OCCUPIED";
    SpotState["Reserved"] = "RESERVED";
    SpotState["Unavailable"] = "UNAVAILABLE";
})(SpotState || (SpotState = {}));
/** Enums. */
export var SpotStatus;
(function (SpotStatus) {
    SpotStatus["Active"] = "ACTIVE";
    /** @deprecated Bridge for legacy 'disabled' rows; remove after deploy. */
    SpotStatus["Disabled"] = "DISABLED";
    SpotStatus["Paused"] = "PAUSED";
    SpotStatus["Suspended"] = "SUSPENDED";
})(SpotStatus || (SpotStatus = {}));
/** Enums. */
export var SystemControllerStatus;
(function (SystemControllerStatus) {
    SystemControllerStatus["Accepted"] = "ACCEPTED";
    SystemControllerStatus["Active"] = "ACTIVE";
    SystemControllerStatus["Idle"] = "IDLE";
    SystemControllerStatus["Pending"] = "PENDING";
    SystemControllerStatus["Suspended"] = "SUSPENDED";
})(SystemControllerStatus || (SystemControllerStatus = {}));
/** Enums. */
export var Taggable;
(function (Taggable) {
    Taggable["Parking"] = "PARKING";
})(Taggable || (Taggable = {}));
/** Enums. */
export var TicketMessageSenderType;
(function (TicketMessageSenderType) {
    TicketMessageSenderType["ParkingOwner"] = "PARKING_OWNER";
    TicketMessageSenderType["Reporter"] = "REPORTER";
    TicketMessageSenderType["Support"] = "SUPPORT";
})(TicketMessageSenderType || (TicketMessageSenderType = {}));
/** Enums. */
export var TicketPriority;
(function (TicketPriority) {
    TicketPriority["High"] = "HIGH";
    TicketPriority["Low"] = "LOW";
    TicketPriority["Medium"] = "MEDIUM";
    TicketPriority["Urgent"] = "URGENT";
})(TicketPriority || (TicketPriority = {}));
/** Enums. */
export var TicketStatus;
(function (TicketStatus) {
    TicketStatus["Closed"] = "CLOSED";
    TicketStatus["InProgress"] = "IN_PROGRESS";
    TicketStatus["New"] = "NEW";
    TicketStatus["Open"] = "OPEN";
    TicketStatus["Reopened"] = "REOPENED";
    TicketStatus["Resolved"] = "RESOLVED";
})(TicketStatus || (TicketStatus = {}));
/** Enums. */
export var TicketType;
(function (TicketType) {
    TicketType["Access"] = "ACCESS";
    TicketType["Compensation"] = "COMPENSATION";
    TicketType["Invoice"] = "INVOICE";
    TicketType["Other"] = "OTHER";
    TicketType["Parking"] = "PARKING";
    TicketType["Payout"] = "PAYOUT";
    TicketType["QrCode"] = "QR_CODE";
    TicketType["Refund"] = "REFUND";
    TicketType["Sign"] = "SIGN";
    TicketType["TechnicalError"] = "TECHNICAL_ERROR";
    TicketType["UnauthorizedParking"] = "UNAUTHORIZED_PARKING";
    TicketType["Wallet"] = "WALLET";
})(TicketType || (TicketType = {}));
/** Enums. */
export var Timezone;
(function (Timezone) {
    Timezone["Amsterdam"] = "AMSTERDAM";
    Timezone["Andorra"] = "ANDORRA";
    Timezone["Astrakhan"] = "ASTRAKHAN";
    Timezone["Athens"] = "ATHENS";
    Timezone["Belgrade"] = "BELGRADE";
    Timezone["Berlin"] = "BERLIN";
    Timezone["Bratislava"] = "BRATISLAVA";
    Timezone["Brussels"] = "BRUSSELS";
    Timezone["Bucharest"] = "BUCHAREST";
    Timezone["Budapest"] = "BUDAPEST";
    Timezone["Busingen"] = "BUSINGEN";
    Timezone["Chisinau"] = "CHISINAU";
    Timezone["Copenhagen"] = "COPENHAGEN";
    Timezone["Dublin"] = "DUBLIN";
    Timezone["Gibraltar"] = "GIBRALTAR";
    Timezone["Guernsey"] = "GUERNSEY";
    Timezone["Helsinki"] = "HELSINKI";
    Timezone["IsleOfMan"] = "ISLE_OF_MAN";
    Timezone["Istanbul"] = "ISTANBUL";
    Timezone["Jersey"] = "JERSEY";
    Timezone["Kaliningrad"] = "KALININGRAD";
    Timezone["Kirov"] = "KIROV";
    Timezone["Kyiv"] = "KYIV";
    Timezone["Lisbon"] = "LISBON";
    Timezone["Ljubljana"] = "LJUBLJANA";
    Timezone["London"] = "LONDON";
    Timezone["Luxembourg"] = "LUXEMBOURG";
    Timezone["Madrid"] = "MADRID";
    Timezone["Malta"] = "MALTA";
    Timezone["Mariehamn"] = "MARIEHAMN";
    Timezone["Minsk"] = "MINSK";
    Timezone["Monaco"] = "MONACO";
    Timezone["Moscow"] = "MOSCOW";
    Timezone["Oslo"] = "OSLO";
    Timezone["Paris"] = "PARIS";
    Timezone["Podgorica"] = "PODGORICA";
    Timezone["Prague"] = "PRAGUE";
    Timezone["Riga"] = "RIGA";
    Timezone["Rome"] = "ROME";
    Timezone["Samara"] = "SAMARA";
    Timezone["SanMarino"] = "SAN_MARINO";
    Timezone["Sarajevo"] = "SARAJEVO";
    Timezone["Saratov"] = "SARATOV";
    Timezone["Simferopol"] = "SIMFEROPOL";
    Timezone["Skopje"] = "SKOPJE";
    Timezone["Sofia"] = "SOFIA";
    Timezone["Stockholm"] = "STOCKHOLM";
    Timezone["Tallinn"] = "TALLINN";
    Timezone["Tirane"] = "TIRANE";
    Timezone["Ulyanovsk"] = "ULYANOVSK";
    Timezone["Uzhgorod"] = "UZHGOROD";
    Timezone["Vaduz"] = "VADUZ";
    Timezone["Vatican"] = "VATICAN";
    Timezone["Vienna"] = "VIENNA";
    Timezone["Vilnius"] = "VILNIUS";
    Timezone["Volgograd"] = "VOLGOGRAD";
    Timezone["Warsaw"] = "WARSAW";
    Timezone["Zagreb"] = "ZAGREB";
    Timezone["Zurich"] = "ZURICH";
})(Timezone || (Timezone = {}));
/** Enums. */
export var Transactable;
(function (Transactable) {
    Transactable["Reservation"] = "RESERVATION";
    Transactable["Withdrawal"] = "WITHDRAWAL";
})(Transactable || (Transactable = {}));
/** Enums. */
export var TransactionType;
(function (TransactionType) {
    TransactionType["Deposit"] = "DEPOSIT";
    TransactionType["Payment"] = "PAYMENT";
    TransactionType["Withdrawal"] = "WITHDRAWAL";
})(TransactionType || (TransactionType = {}));
/** Specify if you want to include or exclude trashed results from a query. */
export var Trashed;
(function (Trashed) {
    /** Only return trashed results. */
    Trashed["Only"] = "ONLY";
    /** Return both trashed and non-trashed results. */
    Trashed["With"] = "WITH";
    /** Only return non-trashed results. */
    Trashed["Without"] = "WITHOUT";
})(Trashed || (Trashed = {}));
/** Enums. */
export var UnavailabilityCalendarDayType;
(function (UnavailabilityCalendarDayType) {
    UnavailabilityCalendarDayType["Full"] = "FULL";
    UnavailabilityCalendarDayType["Partial"] = "PARTIAL";
})(UnavailabilityCalendarDayType || (UnavailabilityCalendarDayType = {}));
/** Enums. */
export var UnavailabilityPlanScope;
(function (UnavailabilityPlanScope) {
    UnavailabilityPlanScope["External"] = "EXTERNAL";
    UnavailabilityPlanScope["Internal"] = "INTERNAL";
})(UnavailabilityPlanScope || (UnavailabilityPlanScope = {}));
/** Enums. */
export var UnavailabilityPlanState;
(function (UnavailabilityPlanState) {
    UnavailabilityPlanState["Disabled"] = "DISABLED";
    UnavailabilityPlanState["Enabled"] = "ENABLED";
})(UnavailabilityPlanState || (UnavailabilityPlanState = {}));
/** Enums. */
export var UnavailabilityPlanStatus;
(function (UnavailabilityPlanStatus) {
    UnavailabilityPlanStatus["Active"] = "ACTIVE";
    UnavailabilityPlanStatus["Archived"] = "ARCHIVED";
    UnavailabilityPlanStatus["Draft"] = "DRAFT";
})(UnavailabilityPlanStatus || (UnavailabilityPlanStatus = {}));
/** Enums. */
export var UnavailabilityRuleScope;
(function (UnavailabilityRuleScope) {
    UnavailabilityRuleScope["External"] = "EXTERNAL";
    UnavailabilityRuleScope["Internal"] = "INTERNAL";
})(UnavailabilityRuleScope || (UnavailabilityRuleScope = {}));
/** Enums. */
export var UnavailabilityRuleStatus;
(function (UnavailabilityRuleStatus) {
    UnavailabilityRuleStatus["Active"] = "ACTIVE";
    UnavailabilityRuleStatus["Inactive"] = "INACTIVE";
})(UnavailabilityRuleStatus || (UnavailabilityRuleStatus = {}));
/** Enums. */
export var UnavailabilityType;
(function (UnavailabilityType) {
    UnavailabilityType["Cyclic"] = "CYCLIC";
    UnavailabilityType["OneTime"] = "ONE_TIME";
})(UnavailabilityType || (UnavailabilityType = {}));
/** The update password statuses. */
export var UpdatePasswordStatus;
(function (UpdatePasswordStatus) {
    /** The updated password status. */
    UpdatePasswordStatus["PasswordUpdated"] = "PASSWORD_UPDATED";
})(UpdatePasswordStatus || (UpdatePasswordStatus = {}));
/** Enums. */
export var UserRole;
(function (UserRole) {
    UserRole["Administrator"] = "ADMINISTRATOR";
    UserRole["Owner"] = "OWNER";
    UserRole["Renter"] = "RENTER";
})(UserRole || (UserRole = {}));
/** Enums. */
export var UserStatus;
(function (UserStatus) {
    UserStatus["Active"] = "ACTIVE";
    UserStatus["Banned"] = "BANNED";
    UserStatus["Created"] = "CREATED";
    UserStatus["Inactive"] = "INACTIVE";
})(UserStatus || (UserStatus = {}));
/** Enums. */
export var VatCategory;
(function (VatCategory) {
    VatCategory["Exempt"] = "EXEMPT";
    VatCategory["Standard"] = "STANDARD";
})(VatCategory || (VatCategory = {}));
/** Enums. */
export var VerificationStatus;
(function (VerificationStatus) {
    VerificationStatus["Accepted"] = "ACCEPTED";
    VerificationStatus["Pending"] = "PENDING";
    VerificationStatus["Rejected"] = "REJECTED";
})(VerificationStatus || (VerificationStatus = {}));
/** Enums. */
export var WalletTransactionType;
(function (WalletTransactionType) {
    WalletTransactionType["Deposit"] = "DEPOSIT";
    WalletTransactionType["Payment"] = "PAYMENT";
    WalletTransactionType["Refund"] = "REFUND";
})(WalletTransactionType || (WalletTransactionType = {}));
/** Enums. */
export var WeekdayKind;
(function (WeekdayKind) {
    WeekdayKind["Friday"] = "FRIDAY";
    WeekdayKind["Holiday"] = "HOLIDAY";
    WeekdayKind["LongWeekend"] = "LONG_WEEKEND";
    WeekdayKind["Monday"] = "MONDAY";
    WeekdayKind["NewYear"] = "NEW_YEAR";
    WeekdayKind["Saturday"] = "SATURDAY";
    WeekdayKind["Sunday"] = "SUNDAY";
    WeekdayKind["Thursday"] = "THURSDAY";
    WeekdayKind["Tuesday"] = "TUESDAY";
    WeekdayKind["Wednesday"] = "WEDNESDAY";
})(WeekdayKind || (WeekdayKind = {}));
export const ConsentRequirementFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ConsentRequirementFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ConsentRequirement' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'currentVersion' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userStatus' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'acceptedVersion' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isAccepted' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'needsUpdate' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const ParkingPathPointFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ParkingPathPointFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ParkingPoint' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'parkingId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'pathIndex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nodeIndex' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'coordinates' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const ParkingReservationSpanFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ParkingReservationSpanFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ParkingReservationSpan' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'registrationNumbers' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parking' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'spot' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const PaymentFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PaymentFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Payment' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'externalPaymentId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'gateway' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'method' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'redirectUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'order' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'product' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'reservationId' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentDocument' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'pdfUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const PaynowClauseFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PaynowClauseFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaynowClausePayload' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                ],
            },
        },
    ],
};
export const PilotFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PilotFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Pilot' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'buttons' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'pilotId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const DirectlyPurchasablePriceRuleFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'DirectlyPurchasablePriceRuleFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DirectlyPurchasablePriceRulePayload' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'period' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'firstPeriodAmount' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                ],
            },
        },
    ],
};
export const PriceRuleFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PriceRuleFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PriceRule' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'parkingId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'period' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'firstPeriodAmount' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nextPeriodsAmount' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'days' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isRevolvable' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                ],
            },
        },
    ],
};
export const SpotFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SpotFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Spot' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'length' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lockCode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'compact' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'covered' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'disabled' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'evChargingAc' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDcUnder100kW' },
                        name: { kind: 'Name', value: 'evChargingDcUnder100kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDc100To200kW' },
                        name: { kind: 'Name', value: 'evChargingDc100To200kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDc200To300kW' },
                        name: { kind: 'Name', value: 'evChargingDc200To300kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDc300To400kW' },
                        name: { kind: 'Name', value: 'evChargingDc300To400kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDcOver400kW' },
                        name: { kind: 'Name', value: 'evChargingDcOver400kw' },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'lockable' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lpgFriendly' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noLpg' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'open24h' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'outdoor' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'secured' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'shelter' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truckUnder7t' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truck7To12t' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truckOver12t' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truckSemi' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'xxlSpace' } },
                ],
            },
        },
    ],
};
export const BillingFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BillingFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Billing' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bankAccount' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'verificationCode' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'verifiedAt' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'vatNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'buildingNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'apartmentNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'invoiceEmail' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isMonthlyBilling' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isInvoiceRequested' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'accruedBalance' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'availableBalance' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'paidOutBalance' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parkings' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'pesel' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'regon' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'representativeFirstName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'representativeLastName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'representativePhoneNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'controllerAgreement' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'citizenship' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'schoolName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'expectedGraduation' } },
                ],
            },
        },
    ],
};
export const ReservationFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ReservationFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Reservation' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'parkingId' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'spans' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lockCode' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'paidAt' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'spot' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withSpot' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SpotFields' } }],
                                    },
                                },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'confirmedAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isRevolving' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceRule' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isRevolvable' } }],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'estimatedPrice' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vehicles' },
                        directives: [
                            {
                                kind: 'Directive',
                                name: { kind: 'Name', value: 'include' },
                                arguments: [
                                    {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'if' },
                                        value: { kind: 'Variable', name: { kind: 'Name', value: 'withVehicle' } },
                                    },
                                ],
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'registrationNumber' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'orders' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'product' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'grossAmount' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withOrder' } },
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'number' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withOrder' } },
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'status' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withOrder' } },
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'payment' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withOrder' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'gateway' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'method' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'redirectUrl' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'paymentDocument' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'pdfUrl' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'renterBilling' },
                        directives: [
                            {
                                kind: 'Directive',
                                name: { kind: 'Name', value: 'include' },
                                arguments: [
                                    {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'if' },
                                        value: { kind: 'Variable', name: { kind: 'Name', value: 'withRenterBilling' } },
                                    },
                                ],
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BillingFields' } }],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parking' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lotMode' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'totalSpots' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'availableSpots' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'addresses' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'googlePlaceId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'coordinates' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'images' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'originalPath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'smallPath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'mediumPath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'largePath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'imageableType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'imageableId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'parkingPoints' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'coordinates' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'spots' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SpotFields' } }],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'openingHours' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'day' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'availableSpotProperties' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'compact' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'covered' } },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'disabled' },
                                                name: { kind: 'Name', value: 'disabledAccess' },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'evChargingAc' } },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDcUnder100kW' },
                                                name: { kind: 'Name', value: 'evChargingDcUnder100kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDc100To200kW' },
                                                name: { kind: 'Name', value: 'evChargingDc100To200kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDc200To300kW' },
                                                name: { kind: 'Name', value: 'evChargingDc200To300kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDc300To400kW' },
                                                name: { kind: 'Name', value: 'evChargingDc300To400kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDcOver400kW' },
                                                name: { kind: 'Name', value: 'evChargingDcOver400kw' },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lpgFriendly' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'noLpg' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'open24h' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'outdoor' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'secured' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'shelter' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'xxlSpace' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SpotFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Spot' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'length' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lockCode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'compact' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'covered' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'disabled' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'evChargingAc' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDcUnder100kW' },
                        name: { kind: 'Name', value: 'evChargingDcUnder100kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDc100To200kW' },
                        name: { kind: 'Name', value: 'evChargingDc100To200kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDc200To300kW' },
                        name: { kind: 'Name', value: 'evChargingDc200To300kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDc300To400kW' },
                        name: { kind: 'Name', value: 'evChargingDc300To400kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDcOver400kW' },
                        name: { kind: 'Name', value: 'evChargingDcOver400kw' },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'lockable' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lpgFriendly' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noLpg' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'open24h' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'outdoor' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'secured' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'shelter' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truckUnder7t' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truck7To12t' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truckOver12t' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truckSemi' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'xxlSpace' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BillingFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Billing' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bankAccount' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'verificationCode' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'verifiedAt' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'vatNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'buildingNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'apartmentNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'invoiceEmail' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isMonthlyBilling' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isInvoiceRequested' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'accruedBalance' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'availableBalance' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'paidOutBalance' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parkings' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'pesel' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'regon' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'representativeFirstName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'representativeLastName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'representativePhoneNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'controllerAgreement' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'citizenship' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'schoolName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'expectedGraduation' } },
                ],
            },
        },
    ],
};
export const TicketFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'TicketFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Ticket' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'ticketableId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'ticketableType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reservation' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ReservationFields' } }],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SpotFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Spot' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'length' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lockCode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'compact' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'covered' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'disabled' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'evChargingAc' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDcUnder100kW' },
                        name: { kind: 'Name', value: 'evChargingDcUnder100kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDc100To200kW' },
                        name: { kind: 'Name', value: 'evChargingDc100To200kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDc200To300kW' },
                        name: { kind: 'Name', value: 'evChargingDc200To300kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDc300To400kW' },
                        name: { kind: 'Name', value: 'evChargingDc300To400kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDcOver400kW' },
                        name: { kind: 'Name', value: 'evChargingDcOver400kw' },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'lockable' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lpgFriendly' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noLpg' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'open24h' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'outdoor' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'secured' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'shelter' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truckUnder7t' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truck7To12t' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truckOver12t' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truckSemi' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'xxlSpace' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BillingFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Billing' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bankAccount' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'verificationCode' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'verifiedAt' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'vatNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'buildingNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'apartmentNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'invoiceEmail' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isMonthlyBilling' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isInvoiceRequested' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'accruedBalance' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'availableBalance' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'paidOutBalance' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parkings' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'pesel' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'regon' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'representativeFirstName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'representativeLastName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'representativePhoneNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'controllerAgreement' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'citizenship' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'schoolName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'expectedGraduation' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ReservationFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Reservation' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'parkingId' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'spans' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lockCode' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'paidAt' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'spot' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withSpot' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SpotFields' } }],
                                    },
                                },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'confirmedAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isRevolving' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceRule' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isRevolvable' } }],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'estimatedPrice' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vehicles' },
                        directives: [
                            {
                                kind: 'Directive',
                                name: { kind: 'Name', value: 'include' },
                                arguments: [
                                    {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'if' },
                                        value: { kind: 'Variable', name: { kind: 'Name', value: 'withVehicle' } },
                                    },
                                ],
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'registrationNumber' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'orders' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'product' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'grossAmount' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withOrder' } },
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'number' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withOrder' } },
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'status' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withOrder' } },
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'payment' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withOrder' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'gateway' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'method' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'redirectUrl' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'paymentDocument' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'pdfUrl' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'renterBilling' },
                        directives: [
                            {
                                kind: 'Directive',
                                name: { kind: 'Name', value: 'include' },
                                arguments: [
                                    {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'if' },
                                        value: { kind: 'Variable', name: { kind: 'Name', value: 'withRenterBilling' } },
                                    },
                                ],
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BillingFields' } }],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parking' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lotMode' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'totalSpots' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'availableSpots' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'addresses' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'googlePlaceId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'coordinates' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'images' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'originalPath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'smallPath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'mediumPath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'largePath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'imageableType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'imageableId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'parkingPoints' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'coordinates' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'spots' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SpotFields' } }],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'openingHours' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'day' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'availableSpotProperties' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'compact' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'covered' } },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'disabled' },
                                                name: { kind: 'Name', value: 'disabledAccess' },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'evChargingAc' } },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDcUnder100kW' },
                                                name: { kind: 'Name', value: 'evChargingDcUnder100kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDc100To200kW' },
                                                name: { kind: 'Name', value: 'evChargingDc100To200kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDc200To300kW' },
                                                name: { kind: 'Name', value: 'evChargingDc200To300kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDc300To400kW' },
                                                name: { kind: 'Name', value: 'evChargingDc300To400kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDcOver400kW' },
                                                name: { kind: 'Name', value: 'evChargingDcOver400kw' },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lpgFriendly' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'noLpg' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'open24h' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'outdoor' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'secured' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'shelter' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'xxlSpace' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const TicketMessageFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'TicketMessageFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TicketMessage' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'body' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'senderType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attachments' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'largeUrl' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const UnavailabilityPlanFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'UnavailabilityPlanFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UnavailabilityPlan' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'parkingId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'spotIds' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'startsAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'endsAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'allDay' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'unavailabilityRules' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'days' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const WalletFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'WalletFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Wallet' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'balance' } },
                ],
            },
        },
    ],
};
export const WalletTransactionFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'WalletTransactionFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WalletTransaction' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'balance' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                ],
            },
        },
    ],
};
export const AvailableSpotsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'AvailableSpots' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'parkingId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'startAt' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTimeUtc' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'endAt' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTimeUtc' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'acceptableRadiusMeters' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'availableSpots' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'parkingId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'parkingId' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'startAt' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'startAt' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'endAt' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'endAt' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'acceptableRadiusMeters' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'acceptableRadiusMeters' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'spots' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'spotId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nearbyParkings' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'parkingId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'distanceMeters' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'spots' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'spotId' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const CheckParkingAvailabilityDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'CheckParkingAvailability' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'from' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTimeUtc' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'to' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTimeUtc' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'parkingId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'checkParkingAvailability' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'from' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'from' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'to' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'to' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'parkingId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'parkingId' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isAvailable' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const BankAccountsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'BankAccounts' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'BankAccountFiltersInput' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bankAccounts' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'page' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filter' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'verificationCode' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'verifiedAt' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'paginatorInfo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const CreateBankAccountDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'CreateBankAccount' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateBankAccountInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createBankAccount' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'verificationCode' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'verifiedAt' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const UpdateBankAccountNameDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'UpdateBankAccountName' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateBankAccountNameInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateBankAccountName' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'verificationCode' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'verifiedAt' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const BillingsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'Billings' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'billings' },
                        arguments: [
                            { kind: 'Argument', name: { kind: 'Name', value: 'first' }, value: { kind: 'IntValue', value: '100' } },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BillingFields' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BillingFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Billing' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bankAccount' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'verificationCode' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'verifiedAt' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'vatNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'buildingNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'apartmentNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'invoiceEmail' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isMonthlyBilling' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isInvoiceRequested' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'accruedBalance' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'availableBalance' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'paidOutBalance' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parkings' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'pesel' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'regon' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'representativeFirstName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'representativeLastName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'representativePhoneNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'controllerAgreement' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'citizenship' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'schoolName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'expectedGraduation' } },
                ],
            },
        },
    ],
};
export const CreateBillingDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'CreateBilling' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateBillingInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createBilling' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const DeleteBillingDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'DeleteBilling' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deleteBilling' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const SelectDefaultBillingDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'SelectDefaultBilling' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectDefaultBilling' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const UpdateBillingDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'UpdateBilling' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateBillingInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateBilling' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const AcceptBillingConsentDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'AcceptBillingConsent' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'AcceptBillingConsentInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'acceptBillingConsent' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'occurredAt' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const AcceptConsentDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'AcceptConsent' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'AcceptConsentInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'acceptConsent' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'occurredAt' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const BillingConsentRequirementsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'BillingConsentRequirements' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'billingId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'billing' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'billingId' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'consentRequirements' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ConsentRequirementFields' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ConsentRequirementFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ConsentRequirement' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'currentVersion' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userStatus' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'acceptedVersion' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isAccepted' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'needsUpdate' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const ControllerBillingConsentRequirementsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ControllerBillingConsentRequirements' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'agreement' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ControllerAgreement' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'controllerBillingConsentRequirements' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'agreement' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'agreement' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ConsentRequirementFields' } }],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ConsentRequirementFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ConsentRequirement' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'currentVersion' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userStatus' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'acceptedVersion' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isAccepted' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'needsUpdate' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const ReservationConsentRequirementsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ReservationConsentRequirements' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reservationConsentRequirements' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ConsentRequirementFields' } }],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ConsentRequirementFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ConsentRequirement' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'currentVersion' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userStatus' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'acceptedVersion' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isAccepted' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'needsUpdate' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const UserAccountConsentRequirementsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'UserAccountConsentRequirements' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userAccountConsentRequirements' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ConsentRequirementFields' } }],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ConsentRequirementFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ConsentRequirement' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'currentVersion' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userStatus' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'acceptedVersion' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isAccepted' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'needsUpdate' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const CheckParkingExistsAtLocationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'CheckParkingExistsAtLocation' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'latitude' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'longitude' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'excludeParkingId' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'checkParkingExistsAtLocation' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'latitude' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'latitude' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'longitude' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'longitude' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'excludeParkingId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'excludeParkingId' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'exists' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const ParkingsForRegistrationNumberCheckDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ParkingsForRegistrationNumberCheck' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parkingsForRegistrationNumberCheck' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const ChangeImagePositionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'ChangeImagePosition' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ChangeImagePositionInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'changeImagePosition' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
};
export const DeleteImageDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'DeleteImage' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deleteImage' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const ImagesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'Images' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'ImageFiltersInput' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'images' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filter' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'page' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'originalPath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'smallPath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'mediumPath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'largePath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'imageableType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'imageableId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const UploadAddressImageDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'UploadAddressImage' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadAddressImageInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'uploadAddressImage' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'originalPath' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'smallPath' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'mediumPath' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'largePath' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'imageableType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'imageableId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const UploadMultipleImagesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'UploadMultipleImages' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadMultipleImagesInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'uploadMultipleImages' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'originalPath' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'smallPath' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'mediumPath' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'largePath' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'imageableType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'imageableId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const UploadParkingImageDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'UploadParkingImage' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadParkingImageInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'uploadParkingImage' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'originalPath' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'smallPath' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'mediumPath' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'largePath' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'imageableType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'imageableId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const UploadSpotImageDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'UploadSpotImage' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadSpotImageInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'uploadSpotImage' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'originalPath' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'smallPath' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'mediumPath' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'largePath' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'imageableType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'imageableId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const ParkingPathsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ParkingPaths' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'parkingId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parkingPoints' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'page' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filter' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'parkingId' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'parkingId' } },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'types' },
                                            value: { kind: 'ListValue', values: [{ kind: 'EnumValue', value: 'PATH' }] },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: {
                                    kind: 'ListValue',
                                    values: [
                                        {
                                            kind: 'ObjectValue',
                                            fields: [
                                                {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'column' },
                                                    value: { kind: 'EnumValue', value: 'PATH_INDEX' },
                                                },
                                                {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'order' },
                                                    value: { kind: 'EnumValue', value: 'ASC' },
                                                },
                                            ],
                                        },
                                        {
                                            kind: 'ObjectValue',
                                            fields: [
                                                {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'column' },
                                                    value: { kind: 'EnumValue', value: 'NODE_INDEX' },
                                                },
                                                {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'order' },
                                                    value: { kind: 'EnumValue', value: 'ASC' },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ParkingPathPointFields' } }],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'paginatorInfo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hasMorePages' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ParkingPathPointFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ParkingPoint' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'parkingId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'pathIndex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nodeIndex' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'coordinates' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const SetParkingPathDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'SetParkingPath' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'SetParkingPathInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'setParkingPath' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const ParkingReservationSpansDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ParkingReservationSpans' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ParkingReservationSpansFiltersInput' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parkingReservationSpans' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filter' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'page' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: {
                                    kind: 'ListValue',
                                    values: [
                                        {
                                            kind: 'ObjectValue',
                                            fields: [
                                                {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'column' },
                                                    value: { kind: 'EnumValue', value: 'STARTS_AT' },
                                                },
                                                {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'order' },
                                                    value: { kind: 'EnumValue', value: 'ASC' },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ParkingReservationSpanFields' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ParkingReservationSpanFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ParkingReservationSpan' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'registrationNumbers' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parking' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'spot' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const ActivateSpotDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'ActivateSpot' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'activateSpot' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const CreateSpotDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'CreateSpot' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateSpotInput' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createSpot' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'length' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lockCode' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'compact' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'covered' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'disabled' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'evChargingAc' } },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'evChargingDcUnder100kW' },
                                    name: { kind: 'Name', value: 'evChargingDcUnder100kw' },
                                },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'evChargingDc100To200kW' },
                                    name: { kind: 'Name', value: 'evChargingDc100To200kw' },
                                },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'evChargingDc200To300kW' },
                                    name: { kind: 'Name', value: 'evChargingDc200To300kw' },
                                },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'evChargingDc300To400kW' },
                                    name: { kind: 'Name', value: 'evChargingDc300To400kw' },
                                },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'evChargingDcOver400kW' },
                                    name: { kind: 'Name', value: 'evChargingDcOver400kw' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'lockable' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lpgFriendly' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'noLpg' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'open24h' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'outdoor' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'secured' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'shelter' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'truckUnder7t' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'truck7To12t' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'truckOver12t' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'truckSemi' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'xxlSpace' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const CreateSpotsFromNumbersDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'CreateSpotsFromNumbers' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateSpotsFromNumbersInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createSpotsFromNumbers' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const DeleteSpotDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'DeleteSpot' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deleteSpot' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const PauseSpotDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'PauseSpot' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pauseSpot' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const SpotsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'Spots' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'SpotFiltersInput' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'spots' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filter' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'page' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SpotFields' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SpotFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Spot' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'length' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lockCode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'compact' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'covered' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'disabled' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'evChargingAc' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDcUnder100kW' },
                        name: { kind: 'Name', value: 'evChargingDcUnder100kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDc100To200kW' },
                        name: { kind: 'Name', value: 'evChargingDc100To200kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDc200To300kW' },
                        name: { kind: 'Name', value: 'evChargingDc200To300kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDc300To400kW' },
                        name: { kind: 'Name', value: 'evChargingDc300To400kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDcOver400kW' },
                        name: { kind: 'Name', value: 'evChargingDcOver400kw' },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'lockable' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lpgFriendly' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noLpg' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'open24h' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'outdoor' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'secured' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'shelter' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truckUnder7t' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truck7To12t' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truckOver12t' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truckSemi' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'xxlSpace' } },
                ],
            },
        },
    ],
};
export const UpdateSpotDetailsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'UpdateSpotDetails' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateSpotDetailsInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateSpotDetails' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'length' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lockCode' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'compact' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'covered' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'disabled' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'evChargingAc' } },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'evChargingDcUnder100kW' },
                                    name: { kind: 'Name', value: 'evChargingDcUnder100kw' },
                                },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'evChargingDc100To200kW' },
                                    name: { kind: 'Name', value: 'evChargingDc100To200kw' },
                                },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'evChargingDc200To300kW' },
                                    name: { kind: 'Name', value: 'evChargingDc200To300kw' },
                                },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'evChargingDc300To400kW' },
                                    name: { kind: 'Name', value: 'evChargingDc300To400kw' },
                                },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'evChargingDcOver400kW' },
                                    name: { kind: 'Name', value: 'evChargingDcOver400kw' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'lockable' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lpgFriendly' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'noLpg' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'open24h' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'outdoor' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'secured' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'shelter' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'truckUnder7t' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'truck7To12t' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'truckOver12t' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'truckSemi' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'xxlSpace' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const UpdateSpotsPropertyDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'UpdateSpotsProperty' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateSpotsPropertyInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateSpotsProperty' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SpotFields' } }],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SpotFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Spot' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'length' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lockCode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'compact' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'covered' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'disabled' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'evChargingAc' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDcUnder100kW' },
                        name: { kind: 'Name', value: 'evChargingDcUnder100kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDc100To200kW' },
                        name: { kind: 'Name', value: 'evChargingDc100To200kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDc200To300kW' },
                        name: { kind: 'Name', value: 'evChargingDc200To300kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDc300To400kW' },
                        name: { kind: 'Name', value: 'evChargingDc300To400kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDcOver400kW' },
                        name: { kind: 'Name', value: 'evChargingDcOver400kw' },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'lockable' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lpgFriendly' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noLpg' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'open24h' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'outdoor' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'secured' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'shelter' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truckUnder7t' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truck7To12t' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truckOver12t' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truckSemi' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'xxlSpace' } },
                ],
            },
        },
    ],
};
export const RegistrationNumberControlDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'RegistrationNumberControl' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'parkingIdentifier' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'registrationNumber' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'registrationNumberControl' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'parkingIdentifier' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'parkingIdentifier' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'registrationNumber' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'registrationNumber' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'case' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const CreateParkingVehicleDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'CreateParkingVehicle' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateParkingVehicleInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createParkingVehicle' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'registrationNumber' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const DeleteParkingVehicleDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'DeleteParkingVehicle' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deleteParkingVehicle' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const ParkingVehiclesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ParkingVehicles' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'parkingId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parkingVehicles' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'parkingId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'parkingId' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'registrationNumber' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const UpdateParkingVehicleDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'UpdateParkingVehicle' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateParkingVehicleInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateParkingVehicle' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'registrationNumber' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const AssignBillingToParkingDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'AssignBillingToParking' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'AssignBillingToParkingInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignBillingToParking' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'parkingId' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const CreateParkingDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'CreateParking' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateParkingInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createParking' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const CreateParkingPointDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'CreateParkingPoint' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateParkingPointInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createParkingPoint' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const DeleteDraftParkingDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'DeleteDraftParking' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deleteDraftParking' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const DisableParkingLotModeDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'DisableParkingLotMode' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'disableParkingLotMode' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lotMode' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const EnableParkingLotModeDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'EnableParkingLotMode' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'enableParkingLotMode' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lotMode' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const EstimateParkingReservationPriceDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'EstimateParkingReservationPrice' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'EstimateParkingReservationPriceInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'estimateParkingReservationPrice' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const ParkingByIdentifierDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ParkingByIdentifier' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'identifier' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'withImages' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    defaultValue: { kind: 'BooleanValue', value: false },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'withOpeningHours' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    defaultValue: { kind: 'BooleanValue', value: false },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'withPackages' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    defaultValue: { kind: 'BooleanValue', value: false },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'withProperties' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    defaultValue: { kind: 'BooleanValue', value: false },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'withSpots' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    defaultValue: { kind: 'BooleanValue', value: false },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parkingByIdentifier' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'identifier' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'identifier' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lotMode' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'totalSpots' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'availableSpots' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'images' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withImages' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'originalPath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'smallPath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'mediumPath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'largePath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'imageableType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'imageableId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'addresses' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'googlePlaceId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'coordinates' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'parkingPoints' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'coordinates' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'spots' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withSpots' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'length' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lockCode' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'compact' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'covered' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'disabled' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'evChargingAc' } },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDcUnder100kW' },
                                                name: { kind: 'Name', value: 'evChargingDcUnder100kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDc100To200kW' },
                                                name: { kind: 'Name', value: 'evChargingDc100To200kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDc200To300kW' },
                                                name: { kind: 'Name', value: 'evChargingDc200To300kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDc300To400kW' },
                                                name: { kind: 'Name', value: 'evChargingDc300To400kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDcOver400kW' },
                                                name: { kind: 'Name', value: 'evChargingDcOver400kw' },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lockable' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lpgFriendly' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'noLpg' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'open24h' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'outdoor' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'secured' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'shelter' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'truckUnder7t' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'truck7To12t' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'truckOver12t' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'truckSemi' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'xxlSpace' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'openingHours' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withOpeningHours' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'day' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'directlyPurchasablePriceRules' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withPackages' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DirectlyPurchasablePriceRuleFields' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'availableSpotProperties' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withProperties' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'compact' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'covered' } },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'disabled' },
                                                name: { kind: 'Name', value: 'disabledAccess' },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'evChargingAc' } },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDcUnder100kW' },
                                                name: { kind: 'Name', value: 'evChargingDcUnder100kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDc100To200kW' },
                                                name: { kind: 'Name', value: 'evChargingDc100To200kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDc200To300kW' },
                                                name: { kind: 'Name', value: 'evChargingDc200To300kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDc300To400kW' },
                                                name: { kind: 'Name', value: 'evChargingDc300To400kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDcOver400kW' },
                                                name: { kind: 'Name', value: 'evChargingDcOver400kw' },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lockable' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lpgFriendly' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'noLpg' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'open24h' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'outdoor' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'secured' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'shelter' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'truckUnder7t' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'truck7To12t' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'truckOver12t' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'truckSemi' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'xxlSpace' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'DirectlyPurchasablePriceRuleFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DirectlyPurchasablePriceRulePayload' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'period' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'firstPeriodAmount' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                ],
            },
        },
    ],
};
export const ParkingOnlyImagesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ParkingOnlyImages' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parkingOnlyImages' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'originalPath' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'smallPath' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'mediumPath' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'largePath' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'imageableType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'imageableId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const ParkingSpotImagesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ParkingSpotImages' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parkingSpotImages' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'originalPath' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'smallPath' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'mediumPath' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'largePath' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'imageableType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'imageableId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const ParkingsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'Parkings' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'ParkingFiltersInput' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'withSpots' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    defaultValue: { kind: 'BooleanValue', value: false },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'withBilling' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    defaultValue: { kind: 'BooleanValue', value: false },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'withPriceRules' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    defaultValue: { kind: 'BooleanValue', value: false },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parkings' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'page' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filter' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lotMode' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'hasSignage' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'totalSpots' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'availableSpots' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'addresses' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'googlePlaceId' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'coordinates' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'parkingPoints' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'coordinates' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                                                                ],
                                                            },
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'spots' },
                                                directives: [
                                                    {
                                                        kind: 'Directive',
                                                        name: { kind: 'Name', value: 'include' },
                                                        arguments: [
                                                            {
                                                                kind: 'Argument',
                                                                name: { kind: 'Name', value: 'if' },
                                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'withSpots' } },
                                                            },
                                                        ],
                                                    },
                                                ],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'length' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'lockCode' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'compact' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'covered' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'disabled' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'evChargingAc' } },
                                                        {
                                                            kind: 'Field',
                                                            alias: { kind: 'Name', value: 'evChargingDcUnder100kW' },
                                                            name: { kind: 'Name', value: 'evChargingDcUnder100kw' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            alias: { kind: 'Name', value: 'evChargingDc100To200kW' },
                                                            name: { kind: 'Name', value: 'evChargingDc100To200kw' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            alias: { kind: 'Name', value: 'evChargingDc200To300kW' },
                                                            name: { kind: 'Name', value: 'evChargingDc200To300kw' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            alias: { kind: 'Name', value: 'evChargingDc300To400kW' },
                                                            name: { kind: 'Name', value: 'evChargingDc300To400kw' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            alias: { kind: 'Name', value: 'evChargingDcOver400kW' },
                                                            name: { kind: 'Name', value: 'evChargingDcOver400kw' },
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'lockable' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'lpgFriendly' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'noLpg' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'open24h' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'outdoor' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'secured' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'shelter' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'truckUnder7t' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'truck7To12t' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'truckOver12t' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'truckSemi' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'xxlSpace' } },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'billing' },
                                                directives: [
                                                    {
                                                        kind: 'Directive',
                                                        name: { kind: 'Name', value: 'include' },
                                                        arguments: [
                                                            {
                                                                kind: 'Argument',
                                                                name: { kind: 'Name', value: 'if' },
                                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'withBilling' } },
                                                            },
                                                        ],
                                                    },
                                                ],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BillingFields' } }],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'openingHours' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'day' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'priceRules' },
                                                directives: [
                                                    {
                                                        kind: 'Directive',
                                                        name: { kind: 'Name', value: 'include' },
                                                        arguments: [
                                                            {
                                                                kind: 'Argument',
                                                                name: { kind: 'Name', value: 'if' },
                                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'withPriceRules' } },
                                                            },
                                                        ],
                                                    },
                                                ],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PriceRuleFields' } }],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'availableSpotProperties' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'compact' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'covered' } },
                                                        {
                                                            kind: 'Field',
                                                            alias: { kind: 'Name', value: 'disabled' },
                                                            name: { kind: 'Name', value: 'disabledAccess' },
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'evChargingAc' } },
                                                        {
                                                            kind: 'Field',
                                                            alias: { kind: 'Name', value: 'evChargingDcUnder100kW' },
                                                            name: { kind: 'Name', value: 'evChargingDcUnder100kw' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            alias: { kind: 'Name', value: 'evChargingDc100To200kW' },
                                                            name: { kind: 'Name', value: 'evChargingDc100To200kw' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            alias: { kind: 'Name', value: 'evChargingDc200To300kW' },
                                                            name: { kind: 'Name', value: 'evChargingDc200To300kw' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            alias: { kind: 'Name', value: 'evChargingDc300To400kW' },
                                                            name: { kind: 'Name', value: 'evChargingDc300To400kw' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            alias: { kind: 'Name', value: 'evChargingDcOver400kW' },
                                                            name: { kind: 'Name', value: 'evChargingDcOver400kw' },
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'lockable' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'lpgFriendly' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'noLpg' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'open24h' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'outdoor' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'secured' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'shelter' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'truckUnder7t' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'truck7To12t' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'truckOver12t' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'truckSemi' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'xxlSpace' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'length' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'maxVehicleWeight' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BillingFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Billing' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bankAccount' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'verificationCode' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'verifiedAt' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'vatNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'buildingNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'apartmentNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'invoiceEmail' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isMonthlyBilling' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isInvoiceRequested' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'accruedBalance' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'availableBalance' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'paidOutBalance' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parkings' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'pesel' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'regon' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'representativeFirstName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'representativeLastName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'representativePhoneNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'controllerAgreement' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'citizenship' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'schoolName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'expectedGraduation' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PriceRuleFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PriceRule' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'parkingId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'period' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'firstPeriodAmount' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nextPeriodsAmount' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'days' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isRevolvable' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                ],
            },
        },
    ],
};
export const PauseParkingDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'PauseParking' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pauseParking' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const SubmitParkingForVerificationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'SubmitParkingForVerification' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'submitParkingForVerification' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const UpdateParkingDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'UpdateParking' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateParkingInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateParking' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const UpdateParkingPointDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'UpdateParkingPoint' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateParkingPointInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateParkingPoint' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const PaymentStatsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'PaymentStats' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentStats' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'hasPayments' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'maxAmount' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const PaymentsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'Payments' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentFiltersInput' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    type: {
                        kind: 'ListType',
                        type: {
                            kind: 'NonNullType',
                            type: { kind: 'NamedType', name: { kind: 'Name', value: 'QueryPaymentsOrderByOrderByClause' } },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'payments' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filter' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'page' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PaymentFields' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PaymentFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Payment' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'externalPaymentId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'gateway' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'method' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'redirectUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'order' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'product' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'reservationId' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentDocument' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'pdfUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const PaynowClausesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'PaynowClauses' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'language' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Language' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paynowClauses' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'language' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'language' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PaynowClauseFields' } }],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PaynowClauseFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaynowClausePayload' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                ],
            },
        },
    ],
};
export const ActivatePilotDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'ActivatePilot' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'activatePilot' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const CreatePilotDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'CreatePilot' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreatePilotInput' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createPilot' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PilotFields' } }],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PilotFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Pilot' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'buttons' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'pilotId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const DeactivatePilotDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'DeactivatePilot' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deactivatePilot' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const DeletePilotDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'DeletePilot' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deletePilot' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const PilotsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'Pilots' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'PilotFiltersInput' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pilots' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'page' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filter' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PilotFields' } }],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'paginatorInfo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PilotFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Pilot' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'buttons' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'pilotId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const SelectDefaultPilotDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'SelectDefaultPilot' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectDefaultPilot' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const UpdateButtonDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'UpdateButton' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateButtonInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateButton' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const UpdatePilotDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'UpdatePilot' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdatePilotInput' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatePilot' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const CreatePriceRuleDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'CreatePriceRule' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreatePriceRuleInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createPriceRule' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const DeletePriceRuleDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'DeletePriceRule' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deletePriceRule' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const PriceRulesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'PriceRules' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'PriceRuleFiltersInput' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceRules' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filter' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PriceRuleFields' } }],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PriceRuleFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PriceRule' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'parkingId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'period' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'firstPeriodAmount' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nextPeriodsAmount' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'days' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isRevolvable' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                ],
            },
        },
    ],
};
export const UpdatePriceRuleDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'UpdatePriceRule' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdatePriceRuleInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatePriceRule' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const UpdatePriceRuleAmountDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'UpdatePriceRuleAmount' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdatePriceRuleAmountInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatePriceRuleAmount' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const InitiateReservationSpanPaymentByLinkDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'InitiateReservationSpanPaymentByLink' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'InitiateReservationSpanPaymentByLinkInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'initiateReservationSpanPaymentByLink' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'paymentUrl' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const ReservationSpanPaymentLinkDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ReservationSpanPaymentLink' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'reservationSpanId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'signature' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reservationSpanPaymentLink' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'reservationSpanId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'reservationSpanId' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'signature' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'signature' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'reservationId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'parkingName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const AddVehicleToReservationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'AddVehicleToReservation' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'AddVehicleToReservationInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'addVehicleToReservation' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'reservationId' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const CancelReservationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'CancelReservation' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cancelReservation' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const CreateReservationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'CreateReservation' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateReservationInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createReservation' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'reservationId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'parkingId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'span' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'spotId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const CreateReservationFromPriceRuleDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'CreateReservationFromPriceRule' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateReservationFromPriceRuleInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createReservationFromPriceRule' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'reservationId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'parkingId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'span' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'spotId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const InitiateReservationPaymentDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'InitiateReservationPayment' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'InitiateReservationPaymentInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'initiateReservationPayment' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'reservationId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'paymentUrl' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const InitiateReservationSpanExtensionPaymentDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'InitiateReservationSpanExtensionPayment' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'InitiateReservationSpanExtensionPaymentInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'initiateReservationSpanExtensionPayment' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'reservationSpanId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'reservationId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'paymentUrl' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const InitiateReservationSpanPaymentDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'InitiateReservationSpanPayment' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'InitiateReservationSpanPaymentInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'initiateReservationSpanPayment' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'reservationSpanId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'reservationId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'paymentUrl' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const ReassignReservationSpanSpotDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'ReassignReservationSpanSpot' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ReassignReservationSpanSpotInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reassignReservationSpanSpot' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'reservationSpanId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'spotId' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const RemoveVehicleFromReservationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'RemoveVehicleFromReservation' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'RemoveVehicleFromReservationInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'removeVehicleFromReservation' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'reservationId' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const RequestReservationSpanExtensionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'RequestReservationSpanExtension' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'RequestReservationSpanExtensionInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requestReservationSpanExtension' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'reservationSpanId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'reservationId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'currentEndAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'newEndAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const RequestReservationSpanPaymentDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'RequestReservationSpanPayment' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'RequestReservationSpanPaymentInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requestReservationSpanPayment' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'reservationSpanId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'reservationId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const ReservationStatsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ReservationStats' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reservationStats' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'hasReservations' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'maxAmount' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const ReservationsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'Reservations' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'ReservationFiltersInput' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    defaultValue: { kind: 'BooleanValue', value: false },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'withVehicle' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    defaultValue: { kind: 'BooleanValue', value: false },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'withSpot' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    defaultValue: { kind: 'BooleanValue', value: false },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'withRenterBilling' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    defaultValue: { kind: 'BooleanValue', value: false },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'withOrder' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    defaultValue: { kind: 'BooleanValue', value: false },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reservations' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filter' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'page' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ReservationFields' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SpotFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Spot' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'length' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lockCode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'compact' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'covered' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'disabled' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'evChargingAc' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDcUnder100kW' },
                        name: { kind: 'Name', value: 'evChargingDcUnder100kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDc100To200kW' },
                        name: { kind: 'Name', value: 'evChargingDc100To200kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDc200To300kW' },
                        name: { kind: 'Name', value: 'evChargingDc200To300kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDc300To400kW' },
                        name: { kind: 'Name', value: 'evChargingDc300To400kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDcOver400kW' },
                        name: { kind: 'Name', value: 'evChargingDcOver400kw' },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'lockable' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lpgFriendly' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noLpg' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'open24h' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'outdoor' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'secured' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'shelter' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truckUnder7t' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truck7To12t' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truckOver12t' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truckSemi' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'xxlSpace' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BillingFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Billing' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bankAccount' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'verificationCode' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'verifiedAt' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'vatNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'buildingNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'apartmentNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'invoiceEmail' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isMonthlyBilling' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isInvoiceRequested' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'accruedBalance' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'availableBalance' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'paidOutBalance' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parkings' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'pesel' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'regon' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'representativeFirstName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'representativeLastName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'representativePhoneNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'controllerAgreement' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'citizenship' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'schoolName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'expectedGraduation' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ReservationFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Reservation' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'parkingId' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'spans' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lockCode' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'paidAt' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'spot' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withSpot' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SpotFields' } }],
                                    },
                                },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'confirmedAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isRevolving' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceRule' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isRevolvable' } }],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'estimatedPrice' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vehicles' },
                        directives: [
                            {
                                kind: 'Directive',
                                name: { kind: 'Name', value: 'include' },
                                arguments: [
                                    {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'if' },
                                        value: { kind: 'Variable', name: { kind: 'Name', value: 'withVehicle' } },
                                    },
                                ],
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'registrationNumber' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'orders' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'product' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'grossAmount' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withOrder' } },
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'number' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withOrder' } },
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'status' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withOrder' } },
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'payment' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withOrder' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'gateway' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'method' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'redirectUrl' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'paymentDocument' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'pdfUrl' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'renterBilling' },
                        directives: [
                            {
                                kind: 'Directive',
                                name: { kind: 'Name', value: 'include' },
                                arguments: [
                                    {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'if' },
                                        value: { kind: 'Variable', name: { kind: 'Name', value: 'withRenterBilling' } },
                                    },
                                ],
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BillingFields' } }],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parking' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lotMode' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'totalSpots' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'availableSpots' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'addresses' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'googlePlaceId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'coordinates' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'images' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'originalPath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'smallPath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'mediumPath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'largePath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'imageableType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'imageableId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'parkingPoints' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'coordinates' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'spots' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SpotFields' } }],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'openingHours' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'day' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'availableSpotProperties' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'compact' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'covered' } },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'disabled' },
                                                name: { kind: 'Name', value: 'disabledAccess' },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'evChargingAc' } },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDcUnder100kW' },
                                                name: { kind: 'Name', value: 'evChargingDcUnder100kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDc100To200kW' },
                                                name: { kind: 'Name', value: 'evChargingDc100To200kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDc200To300kW' },
                                                name: { kind: 'Name', value: 'evChargingDc200To300kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDc300To400kW' },
                                                name: { kind: 'Name', value: 'evChargingDc300To400kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDcOver400kW' },
                                                name: { kind: 'Name', value: 'evChargingDcOver400kw' },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lpgFriendly' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'noLpg' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'open24h' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'outdoor' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'secured' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'shelter' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'xxlSpace' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const SetReservationRevolvingDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'SetReservationRevolving' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'reservationId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'isRevolving' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'setReservationRevolving' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'reservationId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'reservationId' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'isRevolving' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'isRevolving' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isRevolving' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const SwapVehicleInReservationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'SwapVehicleInReservation' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'SwapVehicleInReservationInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'swapVehicleInReservation' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'reservationId' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const DownloadMultipleSpotSignsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'DownloadMultipleSpotSigns' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'spotIds' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'ListType',
                            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'downloadMultipleSpotSigns' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'spotIds' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'spotIds' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'spotId' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'signs' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'pdfUrl' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'template' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'format' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'orientation' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const DownloadParkingMainSignsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'DownloadParkingMainSigns' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'parkingId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'downloadParkingMainSigns' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'parkingId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'parkingId' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'pdfUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'template' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'format' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'orientation' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const DownloadParkingTermSignsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'DownloadParkingTermSigns' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'parkingId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'downloadParkingTermSigns' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'parkingId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'parkingId' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'pdfUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'template' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'format' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'orientation' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const CreateTicketDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'CreateTicket' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateTicketInput' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    defaultValue: { kind: 'BooleanValue', value: false },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'withVehicle' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    defaultValue: { kind: 'BooleanValue', value: true },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'withSpot' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    defaultValue: { kind: 'BooleanValue', value: true },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'withRenterBilling' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    defaultValue: { kind: 'BooleanValue', value: false },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'withOrder' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    defaultValue: { kind: 'BooleanValue', value: false },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createTicket' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'TicketFields' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'messages' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TicketMessageFields' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SpotFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Spot' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'length' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lockCode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'compact' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'covered' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'disabled' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'evChargingAc' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDcUnder100kW' },
                        name: { kind: 'Name', value: 'evChargingDcUnder100kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDc100To200kW' },
                        name: { kind: 'Name', value: 'evChargingDc100To200kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDc200To300kW' },
                        name: { kind: 'Name', value: 'evChargingDc200To300kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDc300To400kW' },
                        name: { kind: 'Name', value: 'evChargingDc300To400kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDcOver400kW' },
                        name: { kind: 'Name', value: 'evChargingDcOver400kw' },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'lockable' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lpgFriendly' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noLpg' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'open24h' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'outdoor' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'secured' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'shelter' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truckUnder7t' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truck7To12t' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truckOver12t' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truckSemi' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'xxlSpace' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BillingFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Billing' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bankAccount' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'verificationCode' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'verifiedAt' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'vatNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'buildingNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'apartmentNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'invoiceEmail' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isMonthlyBilling' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isInvoiceRequested' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'accruedBalance' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'availableBalance' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'paidOutBalance' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parkings' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'pesel' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'regon' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'representativeFirstName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'representativeLastName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'representativePhoneNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'controllerAgreement' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'citizenship' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'schoolName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'expectedGraduation' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ReservationFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Reservation' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'parkingId' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'spans' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lockCode' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'paidAt' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'spot' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withSpot' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SpotFields' } }],
                                    },
                                },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'confirmedAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isRevolving' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceRule' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isRevolvable' } }],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'estimatedPrice' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vehicles' },
                        directives: [
                            {
                                kind: 'Directive',
                                name: { kind: 'Name', value: 'include' },
                                arguments: [
                                    {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'if' },
                                        value: { kind: 'Variable', name: { kind: 'Name', value: 'withVehicle' } },
                                    },
                                ],
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'registrationNumber' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'orders' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'product' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'grossAmount' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withOrder' } },
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'number' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withOrder' } },
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'status' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withOrder' } },
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'payment' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withOrder' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'gateway' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'method' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'redirectUrl' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'paymentDocument' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'pdfUrl' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'renterBilling' },
                        directives: [
                            {
                                kind: 'Directive',
                                name: { kind: 'Name', value: 'include' },
                                arguments: [
                                    {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'if' },
                                        value: { kind: 'Variable', name: { kind: 'Name', value: 'withRenterBilling' } },
                                    },
                                ],
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BillingFields' } }],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parking' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lotMode' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'totalSpots' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'availableSpots' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'addresses' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'googlePlaceId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'coordinates' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'images' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'originalPath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'smallPath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'mediumPath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'largePath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'imageableType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'imageableId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'parkingPoints' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'coordinates' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'spots' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SpotFields' } }],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'openingHours' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'day' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'availableSpotProperties' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'compact' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'covered' } },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'disabled' },
                                                name: { kind: 'Name', value: 'disabledAccess' },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'evChargingAc' } },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDcUnder100kW' },
                                                name: { kind: 'Name', value: 'evChargingDcUnder100kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDc100To200kW' },
                                                name: { kind: 'Name', value: 'evChargingDc100To200kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDc200To300kW' },
                                                name: { kind: 'Name', value: 'evChargingDc200To300kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDc300To400kW' },
                                                name: { kind: 'Name', value: 'evChargingDc300To400kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDcOver400kW' },
                                                name: { kind: 'Name', value: 'evChargingDcOver400kw' },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lpgFriendly' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'noLpg' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'open24h' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'outdoor' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'secured' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'shelter' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'xxlSpace' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'TicketFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Ticket' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'ticketableId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'ticketableType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reservation' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ReservationFields' } }],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'TicketMessageFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TicketMessage' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'body' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'senderType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attachments' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'largeUrl' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const CreateTicketMessageDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'CreateTicketMessage' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateTicketMessageInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createTicketMessage' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TicketMessageFields' } }],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'TicketMessageFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TicketMessage' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'body' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'senderType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attachments' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'largeUrl' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const TicketDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'Ticket' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    defaultValue: { kind: 'BooleanValue', value: false },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'withVehicle' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    defaultValue: { kind: 'BooleanValue', value: true },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'withSpot' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    defaultValue: { kind: 'BooleanValue', value: true },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'withRenterBilling' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    defaultValue: { kind: 'BooleanValue', value: false },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'withOrder' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    defaultValue: { kind: 'BooleanValue', value: false },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ticket' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'TicketFields' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'messages' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TicketMessageFields' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SpotFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Spot' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'length' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lockCode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'compact' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'covered' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'disabled' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'evChargingAc' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDcUnder100kW' },
                        name: { kind: 'Name', value: 'evChargingDcUnder100kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDc100To200kW' },
                        name: { kind: 'Name', value: 'evChargingDc100To200kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDc200To300kW' },
                        name: { kind: 'Name', value: 'evChargingDc200To300kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDc300To400kW' },
                        name: { kind: 'Name', value: 'evChargingDc300To400kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDcOver400kW' },
                        name: { kind: 'Name', value: 'evChargingDcOver400kw' },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'lockable' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lpgFriendly' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noLpg' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'open24h' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'outdoor' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'secured' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'shelter' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truckUnder7t' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truck7To12t' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truckOver12t' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truckSemi' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'xxlSpace' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BillingFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Billing' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bankAccount' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'verificationCode' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'verifiedAt' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'vatNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'buildingNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'apartmentNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'invoiceEmail' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isMonthlyBilling' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isInvoiceRequested' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'accruedBalance' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'availableBalance' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'paidOutBalance' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parkings' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'pesel' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'regon' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'representativeFirstName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'representativeLastName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'representativePhoneNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'controllerAgreement' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'citizenship' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'schoolName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'expectedGraduation' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ReservationFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Reservation' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'parkingId' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'spans' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lockCode' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'paidAt' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'spot' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withSpot' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SpotFields' } }],
                                    },
                                },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'confirmedAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isRevolving' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceRule' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isRevolvable' } }],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'estimatedPrice' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vehicles' },
                        directives: [
                            {
                                kind: 'Directive',
                                name: { kind: 'Name', value: 'include' },
                                arguments: [
                                    {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'if' },
                                        value: { kind: 'Variable', name: { kind: 'Name', value: 'withVehicle' } },
                                    },
                                ],
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'registrationNumber' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'orders' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'product' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'grossAmount' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withOrder' } },
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'number' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withOrder' } },
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'status' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withOrder' } },
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'payment' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withOrder' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'gateway' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'method' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'redirectUrl' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'paymentDocument' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'pdfUrl' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'renterBilling' },
                        directives: [
                            {
                                kind: 'Directive',
                                name: { kind: 'Name', value: 'include' },
                                arguments: [
                                    {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'if' },
                                        value: { kind: 'Variable', name: { kind: 'Name', value: 'withRenterBilling' } },
                                    },
                                ],
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BillingFields' } }],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parking' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lotMode' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'totalSpots' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'availableSpots' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'addresses' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'googlePlaceId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'coordinates' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'images' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'originalPath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'smallPath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'mediumPath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'largePath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'imageableType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'imageableId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'parkingPoints' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'coordinates' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'spots' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SpotFields' } }],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'openingHours' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'day' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'availableSpotProperties' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'compact' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'covered' } },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'disabled' },
                                                name: { kind: 'Name', value: 'disabledAccess' },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'evChargingAc' } },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDcUnder100kW' },
                                                name: { kind: 'Name', value: 'evChargingDcUnder100kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDc100To200kW' },
                                                name: { kind: 'Name', value: 'evChargingDc100To200kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDc200To300kW' },
                                                name: { kind: 'Name', value: 'evChargingDc200To300kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDc300To400kW' },
                                                name: { kind: 'Name', value: 'evChargingDc300To400kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDcOver400kW' },
                                                name: { kind: 'Name', value: 'evChargingDcOver400kw' },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lpgFriendly' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'noLpg' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'open24h' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'outdoor' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'secured' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'shelter' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'xxlSpace' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'TicketFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Ticket' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'ticketableId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'ticketableType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reservation' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ReservationFields' } }],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'TicketMessageFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TicketMessage' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'body' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'senderType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attachments' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'largeUrl' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const TicketsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'Tickets' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'TicketFiltersInput' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    type: {
                        kind: 'ListType',
                        type: {
                            kind: 'NonNullType',
                            type: { kind: 'NamedType', name: { kind: 'Name', value: 'QueryTicketsOrderByOrderByClause' } },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'withMessages' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    defaultValue: { kind: 'BooleanValue', value: false },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    defaultValue: { kind: 'BooleanValue', value: false },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'withVehicle' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    defaultValue: { kind: 'BooleanValue', value: true },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'withSpot' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    defaultValue: { kind: 'BooleanValue', value: true },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'withRenterBilling' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    defaultValue: { kind: 'BooleanValue', value: false },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'withOrder' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    defaultValue: { kind: 'BooleanValue', value: false },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tickets' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filter' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'page' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'TicketFields' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'messages' },
                                                directives: [
                                                    {
                                                        kind: 'Directive',
                                                        name: { kind: 'Name', value: 'include' },
                                                        arguments: [
                                                            {
                                                                kind: 'Argument',
                                                                name: { kind: 'Name', value: 'if' },
                                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'withMessages' } },
                                                            },
                                                        ],
                                                    },
                                                ],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'TicketMessageFields' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SpotFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Spot' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'length' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lockCode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'compact' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'covered' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'disabled' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'evChargingAc' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDcUnder100kW' },
                        name: { kind: 'Name', value: 'evChargingDcUnder100kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDc100To200kW' },
                        name: { kind: 'Name', value: 'evChargingDc100To200kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDc200To300kW' },
                        name: { kind: 'Name', value: 'evChargingDc200To300kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDc300To400kW' },
                        name: { kind: 'Name', value: 'evChargingDc300To400kw' },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'evChargingDcOver400kW' },
                        name: { kind: 'Name', value: 'evChargingDcOver400kw' },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'lockable' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lpgFriendly' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noLpg' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'open24h' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'outdoor' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'secured' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'shelter' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truckUnder7t' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truck7To12t' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truckOver12t' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'truckSemi' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'xxlSpace' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BillingFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Billing' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bankAccount' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'verificationCode' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'verifiedAt' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'vatNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'buildingNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'apartmentNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'invoiceEmail' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isMonthlyBilling' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isInvoiceRequested' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'accruedBalance' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'availableBalance' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'paidOutBalance' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parkings' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'pesel' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'regon' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'representativeFirstName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'representativeLastName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'representativePhoneNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'controllerAgreement' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'citizenship' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'schoolName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'expectedGraduation' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ReservationFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Reservation' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'parkingId' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'spans' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lockCode' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'paidAt' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'spot' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withSpot' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SpotFields' } }],
                                    },
                                },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'confirmedAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isRevolving' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceRule' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isRevolvable' } }],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'estimatedPrice' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vehicles' },
                        directives: [
                            {
                                kind: 'Directive',
                                name: { kind: 'Name', value: 'include' },
                                arguments: [
                                    {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'if' },
                                        value: { kind: 'Variable', name: { kind: 'Name', value: 'withVehicle' } },
                                    },
                                ],
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'registrationNumber' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'orders' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'product' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'grossAmount' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withOrder' } },
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'number' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withOrder' } },
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'status' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withOrder' } },
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'payment' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withOrder' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'gateway' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'method' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'redirectUrl' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'paymentDocument' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'pdfUrl' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'renterBilling' },
                        directives: [
                            {
                                kind: 'Directive',
                                name: { kind: 'Name', value: 'include' },
                                arguments: [
                                    {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'if' },
                                        value: { kind: 'Variable', name: { kind: 'Name', value: 'withRenterBilling' } },
                                    },
                                ],
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BillingFields' } }],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parking' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lotMode' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'totalSpots' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'availableSpots' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'addresses' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'googlePlaceId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'coordinates' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'images' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'originalPath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'smallPath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'mediumPath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'largePath' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'imageableType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'imageableId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'parkingPoints' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'coordinates' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'spots' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SpotFields' } }],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'openingHours' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'day' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'availableSpotProperties' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: { kind: 'Variable', name: { kind: 'Name', value: 'withParking' } },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'compact' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'covered' } },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'disabled' },
                                                name: { kind: 'Name', value: 'disabledAccess' },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'evChargingAc' } },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDcUnder100kW' },
                                                name: { kind: 'Name', value: 'evChargingDcUnder100kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDc100To200kW' },
                                                name: { kind: 'Name', value: 'evChargingDc100To200kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDc200To300kW' },
                                                name: { kind: 'Name', value: 'evChargingDc200To300kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDc300To400kW' },
                                                name: { kind: 'Name', value: 'evChargingDc300To400kw' },
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'evChargingDcOver400kW' },
                                                name: { kind: 'Name', value: 'evChargingDcOver400kw' },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lpgFriendly' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'noLpg' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'open24h' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'outdoor' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'secured' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'shelter' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'xxlSpace' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'TicketFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Ticket' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'ticketableId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'ticketableType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reservation' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ReservationFields' } }],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'TicketMessageFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TicketMessage' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'body' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'senderType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attachments' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'largeUrl' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const OpenCaseDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'OpenCase' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'OpenCaseInput' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'openCase' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const UnauthorizedUseCaseFilesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'UnauthorizedUseCaseFiles' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'unauthorizedUseCase' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'files' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const UploadUnauthorizedUseCaseAttachmentDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'UploadUnauthorizedUseCaseAttachment' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'caseId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'file' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Upload' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'uploadUnauthorizedUseCaseAttachment' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'caseId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'caseId' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'file' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'file' } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
};
export const UnavailabilityCalendarDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'UnavailabilityCalendar' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'parkingId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'fromDate' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'toDate' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'spotId' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'unavailabilityCalendar' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'parkingId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'parkingId' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'fromDate' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'fromDate' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'toDate' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'toDate' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'spotId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'spotId' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'unavailableHours' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const DeleteUnavailabilityPlanDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'DeleteUnavailabilityPlan' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deleteUnavailabilityPlan' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const ReplaceCyclicUnavailabilityDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'ReplaceCyclicUnavailability' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ReplaceCyclicUnavailabilityInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'replaceCyclicUnavailability' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const ReplaceOneTimeUnavailabilityDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'ReplaceOneTimeUnavailability' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ReplaceOneTimeUnavailabilityInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'replaceOneTimeUnavailability' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const SaveCyclicUnavailabilityDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'SaveCyclicUnavailability' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'SaveCyclicUnavailabilityInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'saveCyclicUnavailability' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const SaveOneTimeUnavailabilityDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'SaveOneTimeUnavailability' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'SaveOneTimeUnavailabilityInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'saveOneTimeUnavailability' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const UnavailabilityPlansDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'UnavailabilityPlans' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'UnavailabilityPlanFiltersInput' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderByEndDate' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortOrder' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'unavailabilityPlans' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filter' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'page' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderByEndDate' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderByEndDate' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UnavailabilityPlanFields' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'UnavailabilityPlanFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UnavailabilityPlan' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'parkingId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'spotIds' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'startsAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'endsAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'allDay' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'unavailabilityRules' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'days' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const ApplyReferralCodeDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'ApplyReferralCode' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'applyReferralCode' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'code' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const ConfirmAuthorizationCodeDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'ConfirmAuthorizationCode' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'language' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Language' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'confirmAuthorizationCode' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'code' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'language' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'language' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'tokenType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isNewUser' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'accessToken' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const ConfirmReverificationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'ConfirmReverification' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'confirmReverification' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'code' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'password' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const ConsumeHandoffTokenDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'ConsumeHandoffToken' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'consumeHandoffToken' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'token' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'tokenType' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'accessToken' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const ConsumeImpersonationTokenDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'ConsumeImpersonationToken' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'consumeImpersonationToken' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'token' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'tokenType' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'accessToken' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const ConvertTemporaryUserDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'ConvertTemporaryUser' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'convertTemporaryUser' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'email' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'name' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const ForgotPasswordDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'ForgotPassword' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ForgotPasswordInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forgotPassword' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'status' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const GenerateHandoffTokenDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'GenerateHandoffToken' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'to' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'generateHandoffToken' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'to' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'to' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'handoffToken' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'expiresIn' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const IssueAccessTokenDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'IssueAccessToken' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'issueAccessToken' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const LoginUserDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'LoginUser' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'loginUser' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'email' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'password' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'accessToken' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const MeDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'Me' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'me' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'referral' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'loginMethod' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'ownedPartner' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'referralCode' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const RegisterAsPartnerDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'RegisterAsPartner' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'registerAsPartner' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'referralCode' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const RegisterTemporaryUserWithLoginDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'RegisterTemporaryUserWithLogin' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'registerTemporaryUserWithLogin' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'accessToken' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const RequestAuthorizationCodeDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'RequestAuthorizationCode' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'AuthorizationChannel' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'identifier' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'language' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Language' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requestAuthorizationCode' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'channel' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'identifier' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'identifier' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'language' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'language' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'resendAvailableAt' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const ResetPasswordDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'ResetPassword' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ResetPasswordInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resetPassword' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'status' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const UpdateLoginMethodDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'UpdateLoginMethod' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'method' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'LoginMethod' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'reverificationToken' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateLoginMethod' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'method' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'method' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'reverificationToken' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'reverificationToken' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'password' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'loginMethod' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const UpdateUserAccountDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'UpdateUserAccount' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateUserAccountInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateUserAccount' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const CreateUserVehicleDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'CreateUserVehicle' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateUserVehicleInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createUserVehicle' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'registrationNumber' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const DeleteUserVehicleDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'DeleteUserVehicle' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deleteUserVehicle' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const UpdateUserVehicleDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'UpdateUserVehicle' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateUserVehicleInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateUserVehicle' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'registrationNumber' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const UserVehiclesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'UserVehicles' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'UserVehicleFiltersInput' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userVehicles' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filter' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'registrationNumber' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isPrimary' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const RequestBalanceTopUpDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'RequestBalanceTopUp' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'TopUpWalletBalanceInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requestBalanceTopUp' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'paymentUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'paymentId' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const WalletDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'Wallet' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'me' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'wallet' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'WalletFields' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'WalletFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Wallet' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'balance' } },
                ],
            },
        },
    ],
};
export const WalletTransactionsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'WalletTransactions' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'WalletTransactionFiltersInput' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    type: {
                        kind: 'ListType',
                        type: {
                            kind: 'NonNullType',
                            type: { kind: 'NamedType', name: { kind: 'Name', value: 'QueryWalletTransactionsOrderByOrderByClause' } },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'walletTransactions' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filter' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'page' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'WalletTransactionFields' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'WalletTransactionFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WalletTransaction' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'balance' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                ],
            },
        },
    ],
};
